// import React, { useContext, useEffect, useState } from "react";
// import AdminContext from "../../admin/StateContext/Application";
// import ReactApexChart from "react-apexcharts";
// import DatePicker from "react-datepicker";
// import Select from "react-select";
// import "react-datepicker/dist/react-datepicker.css";
// import "./dashboard.css";
// import { apiurl } from "../../../path";

// // 07-10 for img slide 

// import {
//   FaMapMarkerAlt,
//   FaRegCalendarAlt,
//   FaRegClock,
//   FaMountain,
//   FaBullseye,
//   FaChartBar,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";
// import { TbLocation } from "react-icons/tb";

// import {
//   Approved32,
//   Click32,
//   Disable32,
//   Earnings,
//   Earningss,
//   Earningsss,
//   Error32,
//   fifth,
//   first,
//   forth,
//   Graph64,
//   MoreMenu64,
//   NewTasks64,
//   Sales,
//   Second,
//   Spendthismonth64,
//   third,
//   TotalProjects64,
//   Unclick32,
//   YourBalance,
//   ECSFile,
//   TotalAmountRelease,
//   TotalDeductionAmount,
//   TotalDemandGenerations,
//   TotalWorkOrders,
//   TotalProjectCost,
//   TotalEsitmateAmount,
//   TotalHeadsAssigns,
//   DeleteIcon,
//   EditIcon,
// } from "../../../public/LoginImages/importimages";

// const Dashboard = () => {


//    //07-10 for img slide
//   const [currentSlide, setCurrentSlide] = useState(0);
//     const CARD_THEMES = [
//     { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" }, // blue
//     { border: "#8b5cf6", bg: "#f6f4ff", iconBg: "#e9e4ff", icon: "#8b5cf6" }, // purple
//     { border: "#22a55a", bg: "#f2fbf5", iconBg: "#d5f3e0", icon: "#22a55a" }, // green
//     { border: "#f59e0b", bg: "#fffaf0", iconBg: "#fdebc8", icon: "#f59e0b" }, // orange
//   ];
  
//   const InfoRow = ({ icon, label, value, theme }) => (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "8px",
//         marginBottom: "7px",
//         fontSize: "11px",
//       }}
//     >
//       <span
//         style={{
//           width: "20px",
//           height: "20px",
//           borderRadius: "50%",
//           backgroundColor: theme.iconBg,
//           color: theme.icon,
//           display: "inline-flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "10px",
//           flexShrink: 0,
//         }}
//       >
//         {icon}
//       </span>
//       <span>
//         <b>{label}:</b> {value}
//       </span>
//     </div>
//   );
//   // -----------------
//   const content = useContext(AdminContext);
//   const {
//     GetProjectDashboardData,
//     GetAgencyDashboardData,
//     GetTaxAmounts,
//     GetVendorBills,
//     getTaxAmountsByDate,
//     GetDateWiseData,
//     GetProjectInfo,
//     GetBudgetHeadInfo,
//   } = content;
// // 30-09 for search
// const [projectSearchTerm, setProjectSearchTerm] = useState("");
// const [progressSearchTerm, setProgressSearchTerm] = useState("");
// const [workOrderSearchTerm, setWorkOrderSearchTerm] = useState("");
// const [limitSearchTerm, setLimitSearchTerm] = useState("");
// const [demandSearchTerm, setDemandSearchTerm] = useState("");
// const [deductionSearchTerm, setDeductionSearchTerm] = useState("");
// const [estimateSearchTerm, setEstimateSearchTerm] = useState("");
// const [deductionDetailsSearchTerm, setDeductionDetailsSearchTerm] = useState("");

// // 01-10
//   const [headSearchTerm, setHeadSearchTerm] = useState("");
 


//   const [getData, SetData] = useState({});
//   const [vendorbills, setVendorBills] = useState([]);

//   const [loading, setloading] = useState(true);

//   const [dateData, setDateData] = useState([]);
//   const [projectdata, setProjectData] = useState([]);
//   const [projectId, setProjectId] = useState("");
//   const [headFetchedData, setHeadFetchedData] = useState([]);
//   const [headId, setheadId] = useState("");
//   const [deductionData, setDeductionData] = useState([]);

//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [scheme, setScheme] = useState("");
//  const [FetchedImages, setFetchedImages] = useState([]);
//    const [selectedImage, setSelectedImage] = useState(null);
//    const [selectedUploadId, setSelectedUploadID] = useState();
//  const [showSpecific, setShowSpecific] = useState(0);
//   const [showTable, setShowTable] = useState("");
//   const [projectTableData, setProjectTableData] = useState([]);
//   const [progressTableData, setProgressTableData] = useState([]);
//   const [estimateTableData, setEstimateTableData] = useState([]);
//   const [schemeProjectIds, setSchemeProjectIds] = useState([]);
//   const [headPage, setHeadPage] = useState(1);

//   // ================= ESTIMATE PAGINATION =================
//   const [estimateCurrentPage, setEstimateCurrentPage] = useState(1);
//   const estimatesPerPage = 10;
//   const [limitAllocationTableData, setLimitAllocationTableData] = useState([]);

//   // ================= LIMIT ALLOCATION PAGINATION =================
//   const [limitAllocationCurrentPage, setLimitAllocationCurrentPage] =   useState(1);
//   const limitAllocationsPerPage = 10;
//   const [workOrderTableData, setWorkOrderTableData] = useState([]);
//   const [workOrderCurrentPage, setWorkOrderCurrentPage] = useState(1);
//   const workOrdersPerPage = 10;
//   const [demandTableData, setDemandTableData] = useState([]);

//   // ================= DEMAND PAGINATION =================
//   const [demandCurrentPage, setDemandCurrentPage] = useState(1);
//   const demandsPerPage = 10;

//   const [deductionTableData, setDeductionTableData] = useState([]);

//   // ================= DEDUCTION PAGINATION =================
//   const [deductionCurrentPage, setDeductionCurrentPage] = useState(1);

//   const deductionsPerPage = 10;
//   const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
//   const [deductionDetails, setDeductionDetails] = useState([]);
//   const [showDeductionPage, setShowDeductionPage] = useState(false);

//   // ================= HEAD DETAILS PAGINATION =================
//   const [headDetailsTableData, setHeadDetailsTableData] = useState([]);
//   const [headDetailsCurrentPage, setHeadDetailsCurrentPage] = useState(1);
//   const headDetailsPerPage = 10;

//   // ================= HEAD DETAILS PAGINATION =================
//   const filteredData = headId  ? headFetchedData.filter((item) => item.HeadID == headId) : headFetchedData;
//  // ================= HEAD DETAILS PAGINATION =================
// const headDetailsTableSource = headId ? headDetailsTableData.filter(  (item) => String(item.HeadID) === String(headId), ) : headDetailsTableData;


//   // 22-10
//   // search is applied BEFORE pagination
// const filteredHeadDetailsTableData = headDetailsTableSource.filter((item) => {
//   const s = headSearchTerm.trim().toLowerCase();
//   if (!s) return true;
//   return (
//     String(item.FinancialYear || "").toLowerCase().includes(s) ||
//     String(item.HeadID || "").toLowerCase().includes(s) ||
//     String(item.HeadName || "").toLowerCase().includes(s) ||
//     String(item.ProjectName || "").toLowerCase().includes(s)
//   );
// });

// const headDetailsTotalPages = Math.ceil(
//   filteredHeadDetailsTableData.length / headDetailsPerPage,
// );
// const headDetailsIndexOfLast = headDetailsCurrentPage * headDetailsPerPage;
// const headDetailsIndexOfFirst = headDetailsIndexOfLast - headDetailsPerPage;
// const currentHeadDetails = filteredHeadDetailsTableData.slice(
//   headDetailsIndexOfFirst,
//   headDetailsIndexOfLast,
// );

// useEffect(() => {
//   setHeadDetailsCurrentPage(1);
// }, [headDetailsTableData, headId, headSearchTerm])
//   // ================= LIMIT ALLOCATION PAGINATION =================

//   // 01-10
//   const filteredProjectTableData = (projectTableData || []).filter((item) => {
//   const searchValue = projectSearchTerm.trim().toLowerCase();
 
//   if (!searchValue) return true;
 
//   return (
//     String(item.FinancialYear || "").toLowerCase().includes(searchValue) ||
//     String(item.Scheme || "").toLowerCase().includes(searchValue) ||
//     String(item.ProjectName || "").toLowerCase().includes(searchValue) ||
//     String(item.Agency_Name || item.PIU || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.ProjectCost || "").toLowerCase().includes(searchValue) ||
//     String(item.GRNumber || "").toLowerCase().includes(searchValue)
//   );
// });
 
// const filteredProgressTableData = (progressTableData || []).filter((item) => {
//   const s = progressSearchTerm.trim().toLowerCase();
//   if (!s) return true;
//   return (
//     String(item.ProjectID || "").toLowerCase().includes(s) ||
//     String(item.ProjectName || "").toLowerCase().includes(s) ||
//     String(item.PhysicalProgress || "").toLowerCase().includes(s) ||
//     String(item.Description || "").toLowerCase().includes(s) ||
//     String(item.WorkOrderNo || "").toLowerCase().includes(s)
//   );
// });
 
//   // ================= PROJECT COST PAGINATION =================
//   const [projectCurrentPage, setProjectCurrentPage] = useState(1);

//   const projectsPerPage = 10;

// // 01-10
// const projectTotalPages = Math.ceil(
//   filteredProjectTableData.length / projectsPerPage,
// );
// const projectIndexOfLast = projectCurrentPage * projectsPerPage;
// const projectIndexOfFirst = projectIndexOfLast - projectsPerPage;
// const currentProjectTableData = filteredProjectTableData.slice(
//   projectIndexOfFirst,
//   projectIndexOfLast,
// );
// //23/10 search functionality
// useEffect(() => {
//   setProjectCurrentPage(1);
// }, [projectTableData, projectSearchTerm]);
// // -----------
// // -----------
//   const fmt = (n) => Number(n || 0).toLocaleString("en-IN");

//   // ================= WORK ORDER PAGINATION =================
//   // const workOrderTotalPages = Math.ceil(
//   //   workOrderTableData.length / workOrdersPerPage,
//   // );

//   // const workOrderIndexOfLast = workOrderCurrentPage * workOrdersPerPage;

//   // const workOrderIndexOfFirst = workOrderIndexOfLast - workOrdersPerPage;

//   // const currentWorkOrders = workOrderTableData.slice(
//   //   workOrderIndexOfFirst,
//   //   workOrderIndexOfLast,
//   // );
//   // useEffect(() => {
//   //   setWorkOrderCurrentPage(1);
//   // }, [workOrderTableData]);

//   // ================= PROGRESS PAGINATION =================

//   const [progressCurrentPage, setProgressCurrentPage] = useState(1);

//   const progressesPerPage = 10;

//   // 01-10
//   const progressTotalPages = Math.ceil(

//   filteredProgressTableData.length / progressesPerPage,

// );

// const progressIndexOfLast = progressCurrentPage * progressesPerPage;

// const progressIndexOfFirst = progressIndexOfLast - progressesPerPage;

// const currentProgressTableData = filteredProgressTableData.slice(

//   progressIndexOfFirst,

//   progressIndexOfLast,

// );
 
// useEffect(() => {

//   setProgressCurrentPage(1);

// }, [progressTableData, progressSearchTerm]);
 
//   const COLORS = {
//     purple: "#6656db",
//     blue: "#3cb9e8",
//     aqua: "#26e1d0",
//     green: "#38d1bd",
//     background: "#efecff",
//     gray: "#f7f8fa",
//     darkblue: "#054ecf",
//   };

//   const cardChartStyle = {
//     background: "#fff",
//     borderRadius: "15px",
//     padding: "20px",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     minHeight: "350px",
//   };

//   const selectCommonProps = {
//     styles: {
//       control: (base, state) => ({
//         ...base,
//         minHeight: "42px",
//         height: "42px",
//         width: "100%",
//         borderRadius: "6px",
//         border: state.isFocused ? "1px solid #007bff" : "1px solid #ced4da",
//         boxShadow: state.isFocused ? "0 0 0 1px #007bff" : "none",
//         fontSize: "14px",
//         backgroundColor: "#ffffff",
//         cursor: "pointer",
//       }),

//       valueContainer: (base) => ({
//         ...base,
//         padding: "2px 10px",
//         overflow: "hidden",
//       }),

//       singleValue: (base) => ({
//         ...base,
//         color: "#333333",
//         fontSize: "14px",
//         whiteSpace: "nowrap",
//         overflow: "hidden",
//         textOverflow: "ellipsis",
//       }),

//       placeholder: (base) => ({
//         ...base,
//         color: "#777777",
//         fontSize: "14px",
//         whiteSpace: "nowrap",
//         overflow: "hidden",
//         textOverflow: "ellipsis",
//       }),

//       input: (base) => ({
//         ...base,
//         fontSize: "14px",
//       }),

//       indicatorSeparator: () => ({
//         display: "none",
//       }),

//       dropdownIndicator: (base) => ({
//         ...base,
//         color: "#999999",
//         padding: "6px 8px",
//       }),

//       clearIndicator: (base) => ({
//         ...base,
//         padding: "6px",
//       }),

//       menu: (base) => ({
//         ...base,
//         marginTop: "4px",
//         borderRadius: "6px",
//         overflow: "hidden",
//         boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15)",
//         zIndex: 99999,
//       }),

//       menuList: (base) => ({
//         ...base,
//         maxHeight: "220px",
//         overflowY: "auto",
//         padding: "4px 0",
//       }),

//       option: (base, state) => ({
//         ...base,
//         padding: "10px 12px",
//         fontSize: "14px",
//         backgroundColor: state.isSelected
//           ? "#007bff"
//           : state.isFocused
//             ? "#eaf3ff"
//             : "#ffffff",
//         color: state.isSelected ? "#ffffff" : "#333333",
//         cursor: "pointer",
//       }),

//       menuPortal: (base) => ({
//         ...base,
//         zIndex: 99999,
//       }),
//     },

//     menuPortalTarget: typeof document !== "undefined" ? document.body : null,

//     menuPosition: "fixed",

//     isSearchable: true,

//     isClearable: true,
//   };

//   useEffect(() => {
//     getTaxesAmountbyDate();
//     GetAllProjectTotal();
//     GetHeadBuget();
//      loadHeadTable();
//   }, []);


//   useEffect(() => {
//     const fetchSchemeData = async () => {
//       try {
//         setloading(true);

//         console.log("🔥 Fetching scheme dashboard:", scheme);

//         const data = await GetTaxAmounts(scheme);

//         console.log("🔥 Scheme dashboard response:", data);

//         SetData(data || {});
//       } catch (error) {
//         console.error("GetTaxAmounts error:", error);
//         SetData({});
//       } finally {
//         setloading(false);
//       }
//     };

//     fetchSchemeData();
//   }, [scheme]);
//   useEffect(() => {
//     let cancelled = false;

//     const fetchTableData = async () => {
//       try {
//         const currentProjectId = projectId || "";
//         const currentScheme = scheme || "";
//         const currentSchemeProjectIds = Array.isArray(schemeProjectIds)
//           ? schemeProjectIds
//           : [];

//         const project = await GetProjectDashboardData(
//           currentProjectId,
//           "project",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const progress = await GetProjectDashboardData(
//           currentProjectId,
//           "progress",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const estimate = await GetProjectDashboardData(
//           currentProjectId,
//           "estimateTable",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const limitAllocation = await GetProjectDashboardData(
//           currentProjectId,
//           "limitAllocation",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const workOrders = await GetProjectDashboardData(
//           currentProjectId,
//           "workOrders",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const demands = await GetProjectDashboardData(
//           currentProjectId,
//           "demandGenerations",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         const deductions = await GetProjectDashboardData(
//           currentProjectId,
//           "deductionAmount",
//           "",
//           currentScheme,
//           currentSchemeProjectIds,
//         );

//         if (cancelled) return;

//         const sortedProjects = sortLatestFirst(
//           Array.isArray(project) ? project : [],
//         );
//         const sortedProgress = sortLatestFirst(
//           Array.isArray(progress) ? progress : [],
//         );
//         const sortedEstimates = sortLatestFirst(
//           Array.isArray(estimate) ? estimate : [],
//         );
//         const sortedLimitAllocations = sortLatestFirst(
//           Array.isArray(limitAllocation) ? limitAllocation : [],
//         );
//         const sortedWorkOrders = sortLatestFirst(
//           Array.isArray(workOrders) ? workOrders : [],
//         );
//         const sortedDemands = sortLatestFirst(
//           Array.isArray(demands) ? demands : [],
//         );
//         const sortedDeductions = sortLatestFirst(
//           Array.isArray(deductions) ? deductions : [],
//         );

//         setProjectTableData(sortedProjects);
//         setProgressTableData(sortedProgress);
//         setEstimateTableData(sortedEstimates);
//         setLimitAllocationTableData(sortedLimitAllocations);
//         setWorkOrderTableData(sortedWorkOrders);
//         setDemandTableData(sortedDemands);
//         setDeductionTableData(sortedDeductions);
//         console.log("PROJECT:", project);
//         console.log("ESTIMATE:", estimate);
//         console.log("LIMIT:", limitAllocation);
//         console.log("WORK:", workOrders);
//         console.log("DEMAND:", demands);
//         console.log("DEDUCTION:", deductions);
//       } catch (error) {
//         if (!cancelled) {
//           console.error("❌ Table fetch error:", error);
//         }
//       }
//     };

//     fetchTableData();

//     return () => {
//       cancelled = true;
//     };
//   }, [projectId, scheme, schemeProjectIds]);



//   const GetAllProjectTotal = async () => {
//     try {
//       let data = await GetProjectInfo(" ", "getProjectsByHead");
//       const projects = Array.isArray(data) ? data : [];
//       const uniqueProjects = Array.from(
//         new Map(
//           projects.map((project) => [project.ProjectId, project]),
//         ).values(),
//       );
//       setProjectData(uniqueProjects);
//       setFilteredProjects(uniqueProjects);
//     } catch (err) {
//       console.error("Error fetching projects:", err);
//       setProjectData([]);
//       setFilteredProjects([]);
//     }
//   };

//   const getVendorbill = async () => {
//     let data1 = await GetVendorBills();
//     let bills = data1.filter((item) => item.BillNumber == projectId);
//     setVendorBills(bills);
//   };

//   let vendorBillList = [];
//   if (vendorbills.length > 0) {
//     vendorBillList = vendorbills;
//   }

//   const getTaxesAmountbyDate = async () => {
//     let data = await getTaxAmountsByDate();
//   };

//   const [state, setState] = React.useState({
//     series: [
//       { name: "High - 2013", data: [28, 29, 33, 36, 32, 32, 33] },
//       { name: "Low - 2013", data: [12, 11, 14, 18, 17, 13, 13] },
//     ],
//     options: {
//       chart: {
//         height: 280,
//         type: "line",
//         dropShadow: {
//           enabled: true,
//           top: 8,
//           left: 3,
//           blur: 6,
//           opacity: 0.25,
//           color: "#7f47dd",
//         },
//         zoom: { enabled: false },
//         toolbar: { show: false },
//       },
//       colors: ["#7f47dd", "#407fe4"],
//       dataLabels: { enabled: false },
//       fill: {
//         type: "gradient",
//         gradient: {
//           shade: "light",
//           type: "vertical",
//           shadeIntensity: 0.5,
//           gradientToColors: ["#cadbf8", "#d5b7ad"],
//           inverseColors: false,
//           opacityFrom: 0.5,
//           opacityTo: 0,
//           stops: [0, 100],
//         },
//       },
//       stroke: { width: [7, 7], curve: "straight" },
//       grid: {
//         borderColor: "#e5e7eb",
//         row: { colors: ["#f9fafb", "transparent"], opacity: 0.5 },
//       },
//       markers: { size: 5 },
//       tooltip: { enabled: true, theme: "dark" },
//       animations: {
//         enabled: true,
//         easing: "easeinout",
//         speed: 800,
//         animateGradually: { enabled: true, delay: 150 },
//       },
//       xaxis: {
//         categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
//         labels: { style: { colors: "#6b7280", fontSize: "12px" } },
//       },
//       yaxis: {
//         labels: { style: { colors: "#6b7280", fontSize: "12px" } },
//       },
//       legend: { show: false },
//       responsive: [
//         {
//           breakpoint: 600,
//           options: {
//             chart: { height: 300 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   });

//   const [state1, setState1] = React.useState({
//     series: [
//       { name: "PRODUCT A", data: [44, 55, 41, 67, 22, 43] },
//       { name: "PRODUCT B", data: [13, 23, 20, 8, 13, 27] },
//       { name: "PRODUCT C", data: [11, 17, 15, 15, 21, 14] },
//       { name: "PRODUCT D", data: [21, 7, 25, 13, 22, 8] },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//         stacked: true,
//         toolbar: { show: false },
//         zoom: { enabled: true },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             legend: { position: "bottom", offsetX: -10, offsetY: 0 },
//           },
//         },
//       ],
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           borderRadius: 10,
//           dataLabels: {
//             total: {
//               enabled: true,
//               style: { fontSize: "13px", fontWeight: 900 },
//             },
//           },
//         },
//       },
//       xaxis: {
//         type: "datetime",
//         categories: [
//           "01/01/2011 GMT",
//           "01/02/2011 GMT",
//           "01/03/2011 GMT",
//           "01/04/2011 GMT",
//           "01/05/2011 GMT",
//           "01/06/2011 GMT",
//         ],
//       },
//       yaxis: { labels: { show: false } },
//       legend: { show: false },
//       fill: { opacity: 1 },
//       colors: ["#442cfe", "#5937fd", "#50bdf5", "#cad1e0"],
//     },
//   });

//   const [state4, setState4] = React.useState({
//     series: [0, 0, 0, 0],
//     options: {
//       chart: { type: "donut", width: 320 },
//       labels: [
//         "Project Cost",
//         "Esitmate Amount",
//         "Release Amount",
//         "Demand Generated",
//       ],
//       colors: ["#38d1bd", "#50bdf5", "#ee574c", "#7f47dd"],
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "13px",
//         markers: { radius: 12, width: 12, height: 12 },
//       },
//       dataLabels: {
//         enabled: false, // hide permanent labels — only show on hover via tooltip
//       },
//       tooltip: {
//         custom: function ({ series, seriesIndex, w }) {
//           const label = w.globals.labels[seriesIndex];
//           const raw = w.config.rawValues
//             ? w.config.rawValues[seriesIndex]
//             : series[seriesIndex];

//           return (
//             '<div style="padding:8px 12px;font-size:13px;">' +
//             "<strong>" +
//             label +
//             "</strong><br/>" +
//             "₹ " +
//             Number(raw || 0).toLocaleString("en-IN") +
//             "</div>"
//           );
//         },
//       },
//       rawValues: [0, 0, 0, 0],
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: { width: 240 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   });
//   useEffect(() => {
//     const data = projectId ? dateData : getData;

//     const raw = [
//       Number(data?.Project_Cost || 0),
//       Number(data?.Esitmate_Amount || 0),
//       Number(data?.ReleaseAmountTillDate || 0),
//       Number(data?.LiabalityAmount || 0),
//     ];

//     // log10 compresses huge magnitude gaps far more aggressively than sqrt
//     // +1 avoids log(0) = -Infinity for genuinely zero values
//     const transformed = raw.map((v) => (v > 0 ? Math.log10(v + 1) : 0));

//     setState4((prevState) => ({
//       ...prevState,
//       series: transformed,
//       options: {
//         ...prevState.options,
//         rawValues: raw,
//       },
//     }));
//   }, [getData, dateData, projectId]);

//   // add for by default tax and amont chart
//   useEffect(() => {
//     const hasData =
//       (deductionData && deductionData.length > 0) ||
//       (getData && Object.keys(getData).length > 0) ||
//       (dateData && Object.keys(dateData).length > 0);

//     if (hasData) {
//       const timer = setTimeout(() => {
//         window.dispatchEvent(new Event("resize"));
//       }, 150);
//       return () => clearTimeout(timer);
//     }
//   }, [getData, dateData, deductionData]);

//   const [state5, setState5] = useState({
//     series: [],
//     options: {
//       chart: { width: 380, type: "pie" },
//       labels: [],
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "14px",
//         markers: { radius: 12 },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: { width: 200 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   });

//   useEffect(() => {
//     if (deductionData && deductionData.length > 0) {
//       const labels = deductionData.map((item) => item.TypeOfAmount);
//       const series = deductionData.map((item) => parseFloat(item.TotalAmount));

//       setState5((prev) => ({
//         ...prev,
//         series: series,
//         options: { ...prev.options, labels: labels },
//       }));
//     }
//   }, [deductionData]);

//   // ================= VENDOR BILL PAGINATION =================
//   // ================= vendor PAGINATION =================
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 2;
//   const totalPages = Math.ceil(vendorbills.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   const currentBills = vendorbills.slice(indexOfFirstBill, indexOfLastBill);

//   // ================= HEAD PAGINATION =================
//   const [headCurrentPage, setHeadCurrentPage] = useState(1);
//   const headsPerPage = 8;
//   // const headTableData = Object.entries(
//   //   headFetchedData.reduce((acc, val) => {
//   //     acc[val.BudgetHead] =
//   //       (acc[val.BudgetHead] || 0) + (parseFloat(val.EsitmateAmount) || 0);
//   //     return acc;
//   //   }, {}),
//   // );
//   const headTableData = Object.entries(
//     headFetchedData.reduce((acc, val) => {
//       const headName = val.HeadName || "-";

//       acc[headName] =
//         (acc[headName] || 0) + (parseFloat(val.HeadSanctionAmount) || 0);

//       return acc;
//     }, {}),
//   );
//   console.log("head fetch ---", headFetchedData[0]);
//   const headTotalPages = Math.ceil(headTableData.length / headsPerPage);
//   const headIndexOfLast = headCurrentPage * headsPerPage;
//   const headIndexOfFirst = headIndexOfLast - headsPerPage;
//   const currentHeads = headTableData.slice(headIndexOfFirst, headIndexOfLast);

//   const getDateWiseData = async () => {
//     if (!projectId) return;
//     setloading(true);
//     const data = await GetDateWiseData(projectId, "Projectfetching");

//     if (data) {
//       setDateData(data);
//       setloading(false);
//     }
//   };

//   const GetHeadBugetEstimationTable = async (PID) => {
//     try {
//       let res = await GetProjectInfo(PID, "getprojectHeadEstimationamount");
//       console.log("PROJECT HEAD RESPONSE:--", res);
//       setHeadFetchedData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("GetHeadBugetEstimationTable error:", err);
//       setHeadFetchedData([]);
//       console.log(err);
//     }
//   };

//   const GetHeadBuget = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "all");
//       console.log("ALL HEAD RESPONSE:", res);
//       setHeadFetchedData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.error("GetHeadBuget error:", err);

//       console.log(err);
//     }
//   };


//   useEffect(() => {
//     const fetchHeadData = async () => {
//       if (!headId) {
//         return;
//       }
//       try {
//         const headData = await GetBudgetHeadInfo(
//           projectId,
//           "getHeadSpecificAmounts",
//           headId,
//         );
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (projectId && headId) {
//       fetchHeadData();
//     }
//   }, [projectId, headId]);

//   useEffect(() => {
//     if (projectId === "") {
//       setDateData({});
//       return;
//     }

//     getDateWiseData();
//     getVendorbill();
//   }, [projectId]);

//   const getDeductionData = async () => {
//     try {
//       setloading(true);
//       const data = await GetDateWiseData(projectId, "deductionFetching");
//       setDeductionData(data);
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setloading(false);
//     }
//   };

//   useEffect(() => {
//     if (projectId) {
//       getDeductionData();
//     }
//   }, [projectId]);

//   const [search, setSearch] = useState("");

//   const displayData = projectId ? dateData : getData;



// const schemeProjectCost = React.useMemo(() => {
//   if (!scheme) return getData.Project_Cost || 0;
//   return filteredProjects.reduce(
//     (sum, project) => sum + Number(project.ProjectCost || 0),
//     0,
//   );
// }, [scheme, filteredProjects, getData.Project_Cost]);

// // here add the head dropdown which show only which are used in projcet 11-09

// // Set of HeadIDs that are actually assigned to at least one project
// const usedHeadIds = React.useMemo(() => {
//   return new Set(
//     (projectdata || [])
//       .map((p) => p.HeadID)
//       .filter((id) => id !== undefined && id !== null && id !== "")
//       .map((id) => String(id)),
//   );
// }, [projectdata]);

// // Filter + de-duplicate headFetchedData down to only used heads
// const usedHeads = React.useMemo(() => {
//   const filtered = (headFetchedData || []).filter((head) =>
//     usedHeadIds.has(String(head.HeadID)),
//   );
//   return Array.from(
//     new Map(filtered.map((head) => [head.HeadID, head])).values(),
//   );
// }, [headFetchedData, usedHeadIds]);

// // react-select options built from the filtered list
// const headOptions = React.useMemo(() => {
//   return usedHeads.map((head) => ({
//     value: String(head.HeadID),
//     label: head.HeadName || head.BudgetHead || "-",
//   }));
// }, [usedHeads]);

// // currently selected option object for react-select's `value` prop
// const selectedHeadOption = React.useMemo(() => {
//   return headOptions.find((option) => option.value === String(headId)) || null;
// }, [headOptions, headId]);




//   const searchedProjects = (filteredProjects || []).filter((p) =>
//     p.ProjectName?.toLowerCase().includes(search.trim().toLowerCase()),
//   );

//   const totalLimitAllocationAmount = React.useMemo(() => {
//     return limitAllocationTableData.reduce(
//       (sum, item) =>
//         sum + Number(item.ReleaseAmountTillDate || item.ReleaseAmount || 0),
//       0,
//     );
//   }, [limitAllocationTableData]);

//   const handleSchemeChange = (e) => {
//     const selectedScheme = e.target.value;

//     setScheme(selectedScheme);
//     setProjectId("");
//     setheadId("");

//     setDateData({});
//     setVendorBills([]);
//     setDeductionData([]);

//     setProjectTableData([]);
//     setEstimateTableData([]);
//     setLimitAllocationTableData([]);
//     setWorkOrderTableData([]);
//     setDemandTableData([]);
//     setDeductionTableData([]);

//     if (!selectedScheme) {
//       setFilteredProjects(projectdata);
//       setSchemeProjectIds([]);
//       return;
//     }

//     const schemeProjects = projectdata.filter(
//       (project) =>
//         String(project.Scheme).trim() === String(selectedScheme).trim(),
//     );

//     const uniqueProjects = Array.from(
//       new Map(
//         schemeProjects.map((project) => [project.ProjectId, project]),
//       ).values(),
//     );

//     setFilteredProjects(uniqueProjects);

//     const projectIds = uniqueProjects
//       .map((project) => project.ProjectId)
//       .filter(Boolean);

//     setSchemeProjectIds(projectIds);
//   };

//   const handleHeadChange = (e) => {
//     // const selectedHeadId = e.target.value;
//     const selectedHeadId = String(e.target.value || "");

//     setheadId(selectedHeadId);
//     setProjectId("");

//     if (!selectedHeadId) {
//       //  const projects = scheme
//       // ? projectdata.filter(
//       //     (project) =>
//       //       String(project.Scheme).trim() ===
//       //       String(scheme).trim()
//       //   )
//       // : projectdata;
//       setFilteredProjects(projectdata);
//       return;
//     }
//     const projectsForHead = projectdata.filter(
//       (project) => String(project.HeadID) === String(selectedHeadId),
//       //       (project) =>
//       //     String(project.HeadID) === selectedHeadId &&
//       //     (!scheme ||
//       //       String(project.Scheme).trim() === String(scheme).trim())
//     );
//     // );

//     const uniqueProjects = Array.from(
//       new Map(
//         projectsForHead.map((project) => [project.ProjectId, project]),
//       ).values(),
//     );
//     setFilteredProjects(uniqueProjects);
//   };

//   const selectedProject = projectdata.find(
//     (p) => String(p.ProjectId) === String(projectId),
//   );

//   const handleProjectChange = (e) => {
//     const selectedProjectId = e.target.value;
//     setProjectId(selectedProjectId);
//   };

//   const projectOptions = searchedProjects.map((p) => ({
//     value: String(p.ProjectId),
//     label: p.ProjectName,
//   }));

//   const getDeductionDetails = async (workOrderUID) => {
//     setSelectedWorkOrder(workOrderUID);
// setDeductionDetailsSearchTerm("");//22-10
//     const response = await GetProjectDashboardData(
//       projectId,
//       "deductionDetails",
//       workOrderUID,
//     );

//     setDeductionDetails(Array.isArray(response) ? response : []);
//     setShowTable("deductionDetails");
//   };

//   const loadHeadTable = async () => {
//     try {
//       const data = await GetProjectDashboardData(projectId || "", "head");
//       setHeadDetailsTableData(Array.isArray(data) ? data : []);
//     } catch (err) {
//       console.error(err);
//       setHeadDetailsTableData([]);
//     }
//   };
//   useEffect(() => {
//     if (projectId) {
//       loadHeadTable();
//     }
//   }, [projectId]);
// // 12-09
//   // const headsAssignsCount = projectId
//   //   ? headDetailsTableData.length
//   //   : filteredData.length;

//   const headsAssignsCount = headDetailsTableSource.length;

//   const headTableSource = projectId ? headDetailsTableData : filteredData;


//   //24/10 search clear
//   const clearAllSearchTerms = () => {
//   setProjectSearchTerm("");
//   setProgressSearchTerm("");
//   setWorkOrderSearchTerm("");
//   setLimitSearchTerm("");
//   setDemandSearchTerm("");
//   setDeductionSearchTerm("");
//   setEstimateSearchTerm("");
//   setHeadSearchTerm("");
// };

//   const getPageNumbers = (currentPage, totalPages) => {
//     const maxVisiblePages = 10;

//     if (totalPages <= maxVisiblePages) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     if (currentPage <= 3) {
//       return [1, 2, 3, 4, 5, "...", totalPages];
//     }

//     if (currentPage >= totalPages - 2) {
//       return [
//         "...",
//         totalPages - 4,
//         totalPages - 3,
//         totalPages - 2,
//         totalPages - 1,
//         totalPages,
//       ];
//     }

//     return [
//       "...",
//       currentPage - 2,
//       currentPage - 1,
//       currentPage,
//       currentPage + 1,
//       currentPage + 2,
//       "...",
//       totalPages,
//     ];
//   };
//   // const headOptions = (headFetchedData || []).map((head) => ({
//   //   value: String(head.HeadID),
//   //   label: head.HeadName || head.BudgetHead || "-",
//   // }));

//   // const selectedHeadOption =
//   //   headOptions.find((option) => option.value === String(headId)) || null;


    
//   const sortLatestFirst = (list) => {
//     if (!Array.isArray(list)) return [];
//     return [...list].sort((a, b) => {
//       const dateA = new Date(
//         a.Date || a.CreatedAt || a.CreationDate || 0,
//       ).getTime();
//       const dateB = new Date(
//         b.Date || b.CreatedAt || b.CreationDate || 0,
//       ).getTime();
//       return dateB - dateA;
//     });
//   };


// const fetchSpecficUploadPhoto = async (
//   uploadID,
//   WorkOrderNo,
//   physicalWork
// ) => {
//   try {
//     console.log("🔥 UploadID sent:", uploadID);

//     const res = await GetBudgetHeadInfo(
//       uploadID,
//       "GetSpecificUploadImagesfromProgressTable"
//     );

//     console.log("🔥 RAW API RESPONSE:", res);

//     const allImages = Array.isArray(res)
//       ? res
//       : Array.isArray(res?.Data)
//         ? res.Data
//         : [];

//     console.log("🔥 ALL IMAGES:", allImages);

//     const filteredImages = allImages.filter(
//       (image) =>
//         String(image.UploadID).trim() === String(uploadID).trim()
//     );

//     console.log("🔥 MATCHED IMAGES:", filteredImages);

//     setFetchedImages(filteredImages);
//     setSelectedUploadID(uploadID);
//      setCurrentSlide(0); // <-- add this 07-10
//     setShowSpecific(1);

//   } catch (err) {
//     console.error("❌ Image API error:", err);
//   }
// };






// // 30-09 for search
// const filteredLimitAllocationTableData =
//   (limitAllocationTableData || []).filter((item) => {
//     const searchValue = limitSearchTerm.trim().toLowerCase();
 
//     if (!searchValue) return true;
 
//     return (
//       String(item.ProjectName || "").toLowerCase().includes(searchValue) ||
//       String(item.FinancialYear || "").toLowerCase().includes(searchValue) ||
//       String(item.AgencyName || "").toLowerCase().includes(searchValue) ||
//       String(item.Agency_Name || "").toLowerCase().includes(searchValue) ||
//       String(item.LimitAmount || "").toLowerCase().includes(searchValue) ||
//       String(item.ReleaseAmount || "").toLowerCase().includes(searchValue)
//     );
//   });
//   const filteredDemandTableData = (demandTableData || []).filter((item) => {
//   const searchValue = demandSearchTerm.trim().toLowerCase();
 
//   if (!searchValue) return true;
 
//   return (
//     String(item.DemandGenerationID || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.RABillNumber || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.ContractorName || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.WorkName || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.BillAmount || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.DeductionAmount || "")
//       .toLowerCase()
//       .includes(searchValue) ||
//     String(item.NetPayableAmount || "")
//       .toLowerCase()
//       .includes(searchValue)
//   );
// });
// const filteredWorkOrderTableData = (workOrderTableData || []).filter((item) => {
//   const searchValue = workOrderSearchTerm.trim().toLowerCase();
 
//   if (!searchValue) return true;
//   return (
//     String(item.FinancialYear || "").toLowerCase().includes(searchValue) ||
//     String(item.ProjectName || "").toLowerCase().includes(searchValue) ||
//     String(item.ProjectCost || "").toLowerCase().includes(searchValue) ||
//     String(item.CreatedByAgency || "").toLowerCase().includes(searchValue) ||
//     String(item.WorkName || "").toLowerCase().includes(searchValue) ||
//     String(item.WorkOrderNo || "").toLowerCase().includes(searchValue)
//   );
// });
// // 15-10
// // 15-10 
// const getDeductionTotal = (item) =>
//   Number(item.TotalDeductionAmount ?? item.DeductionAmount ?? 0);
// const filteredDeductionTableData = (deductionTableData || [])
//   .filter((item) => getDeductionTotal(item) > 0)
//   .filter((item) => {
//     const searchValue = deductionSearchTerm.trim().toLowerCase();

//     if (!searchValue) return true;

//     return (
//       String(item.WorkOrderUID || "").toLowerCase().includes(searchValue) ||
//       String(item.WorkOrderNo || "").toLowerCase().includes(searchValue) ||
//       String(item.ProjectName || "").toLowerCase().includes(searchValue) ||
//       String(item.WorkName || "").toLowerCase().includes(searchValue) ||
//       String(item.Name || "").toLowerCase().includes(searchValue) ||
//       String(item.ContractorName || "").toLowerCase().includes(searchValue) ||
//       String(item.AgencyName || "").toLowerCase().includes(searchValue)
//     );
//   });
 
// // 22-10
//   // DEDUCTION DETAILS SEARCH
// const filteredDeductionDetails = (deductionDetails || []).filter((item) => {
//   const s = deductionDetailsSearchTerm.trim().toLowerCase();
//   if (!s) return true;
//   return (
//     String(item.DeductionName || "").toLowerCase().includes(s) ||
//     String(item.DeductionAmount || "").toLowerCase().includes(s) ||
//     fmt(item.DeductionAmount).toLowerCase().includes(s)
//   );
// });

// // ================= ESTIMATE SEARCH =================
// const filteredEstimateTableData = (estimateTableData || []).filter((item) => {
//   const s = estimateSearchTerm.trim().toLowerCase();
//   if (!s) return true;
//   return (
//     String(item.ProjectID || "").toLowerCase().includes(s) ||
//     String(item.ProjectName || "").toLowerCase().includes(s) ||
//     String(item.Year || "").toLowerCase().includes(s) ||
//     String(item.BudgetHead || "").toLowerCase().includes(s) ||
//     String(item.ObjectCode || "").toLowerCase().includes(s) ||
//     String(item.EsitmateAmount || "").toLowerCase().includes(s)
//   );
// });
 
// // ================= COMMON PAGINATE HELPER =================
// const paginate = (list, page, perPage) => {
//   const last = page * perPage;
//   const first = last - perPage;
//   return {
//     totalPages: Math.ceil(list.length / perPage),
//     first,
//     last,
//     items: list.slice(first, last),
//   };
// };
 
// // ESTIMATE
// const {
//   totalPages: estimateTotalPages,
//   first: estimateIndexOfFirst,
//   last: estimateIndexOfLast,
//   items: currentEstimates,
// } = paginate(filteredEstimateTableData, estimateCurrentPage, estimatesPerPage);
 
// // LIMIT ALLOCATION
// const {
//   totalPages: limitAllocationTotalPages,
//   first: limitAllocationIndexOfFirst,
//   last: limitAllocationIndexOfLast,
//   items: currentLimitAllocations,
// } = paginate(filteredLimitAllocationTableData, limitAllocationCurrentPage, limitAllocationsPerPage);
 
// // WORK ORDER
// const {
//   totalPages: workOrderTotalPages,
//   first: workOrderIndexOfFirst,
//   last: workOrderIndexOfLast,
//   items: currentWorkOrders,
// } = paginate(filteredWorkOrderTableData, workOrderCurrentPage, workOrdersPerPage);
 
// // DEMAND
// const {
//   totalPages: demandTotalPages,
//   first: demandIndexOfFirst,
//   last: demandIndexOfLast,
//   items: currentDemands,
// } = paginate(filteredDemandTableData, demandCurrentPage, demandsPerPage);
 
// // DEDUCTION
// const {
//   totalPages: deductionTotalPages,
//   first: deductionIndexOfFirst,
//   last: deductionIndexOfLast,
//   items: currentDeductions,
// } = paginate(filteredDeductionTableData, deductionCurrentPage, deductionsPerPage);
 
 
// useEffect(() => { setEstimateCurrentPage(1); }, [estimateTableData, estimateSearchTerm]);
// useEffect(() => { setLimitAllocationCurrentPage(1); }, [limitAllocationTableData, limitSearchTerm]);
// useEffect(() => { setWorkOrderCurrentPage(1); }, [workOrderTableData, workOrderSearchTerm]);
// useEffect(() => { setDemandCurrentPage(1); }, [demandTableData, demandSearchTerm]);
// useEffect(() => { setDeductionCurrentPage(1); }, [deductionTableData, deductionSearchTerm]);
 
 
// //  ----------------
// // 01-10

// // const filteredHeadDetailsTableData = (headDetailsTableSource || []).filter(
// //   (item) => {
// //     const s = headSearchTerm.trim().toLowerCase();
 
// //     if (!s) return true;
 
// //     return (
// //       String(item.FinancialYear || "").toLowerCase().includes(s) ||
// //       String(item.HeadID || "").toLowerCase().includes(s) ||
// //       String(item.HeadName || "").toLowerCase().includes(s) ||
// //       String(item.ProjectName || "").toLowerCase().includes(s)
// //     );
// //   }
// // );

 

// // 07-10 for img slide
// const parseLocations = (location) => {
//   try {
//     if (Array.isArray(location)) {
//       return location.map((loc) =>
//         typeof loc === "string" ? JSON.parse(loc) : loc,
//       );
//     }
//     const parsed = JSON.parse(location || "[]");
//     return parsed.map((loc) =>
//       typeof loc === "string" ? JSON.parse(loc) : loc,
//     );
//   } catch {
//     return [];
//   }
// };

// const renderPhotoViewer = () => {
//   const cards = [];
//   (FetchedImages || []).forEach((val, index) => {
//     const images = val.Upload
//       ? val.Upload.split(",").map((img) => img.trim())
//       : [];

//     const locations = (() => {
//       try {
//         if (!val.Location) return [];
//         if (
//           typeof val.Location === "string" &&
//           val.Location.includes(",") &&
//           !val.Location.startsWith("[")
//         ) {
//           const [lat, lng] = val.Location.split(",");
//           const dt = val.Date ? new Date(val.Date) : null;
//           return [
//             {
//               latitude: lat?.trim(),
//               longitude: lng?.trim(),
//               date: dt ? dt.toLocaleDateString("en-GB") : "-",
//               time: dt
//                 ? dt.toLocaleTimeString("en-GB", { hour12: false })
//                 : "-",
//               elevation: "",
//               accuracy: "",
//             },
//           ];
//         }
//         return parseLocations(val.Location);
//       } catch {
//         return [];
//       }
//     })();

//     images.forEach((img, imgIndex) => {
//       cards.push({
//         key: `${index}-${imgIndex}`,
//         img,
//         location: locations[imgIndex] || locations[0] || {},
//         progress: val.PhysicalProgress,
//       });
//     });
//   });

//   const total = cards.length;
//   const current = cards[currentSlide] || cards[0];
//   const theme = CARD_THEMES[0];
//   const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
//   const goNext = () => setCurrentSlide((p) => (p + 1) % total);

//   const arrowStyle = (side) => ({
//     position: "absolute",
//     top: "50%",
//     [side]: "10px",
//     transform: "translateY(-50%)",
//     width: "34px",
//     height: "34px",
//     borderRadius: "50%",
//     border: "none",
//     backgroundColor: "rgba(255,255,255,0.92)",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
//     color: "#333",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     cursor: "pointer",
//     zIndex: 2,
//   });

//   const location = current?.location || {};

//   return (
//     <div
//       className="col-12"
//       style={{
//         backgroundColor: "#fff",
//         height: "89vh",
//         overflowX: "hidden",
//         overflowY: "auto",
//         padding: "20px 24px",
//       }}
//     >
//       <h6
//         className="fw-bold mb-4"
//         style={{ fontSize: "20px", textAlign: "center" }}
//       >
//         Uploaded Id: {selectedUploadId}
//       </h6>

//       {total > 0 ? (
//         <div
//           style={{
//             maxWidth: "380px",
//             margin: "0 auto",
//             border: `1.5px solid ${theme.border}`,
//             borderRadius: "10px",
//             backgroundColor: theme.bg,
//             padding: "10px",
//           }}
//         >
//           {/* Photo slider */}
//           <div
//             style={{
//               position: "relative",
//               width: "100%",
//               height: "240px",
//               borderRadius: "14px",
//               overflow: "hidden",
//               backgroundColor: "#eee",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 height: "100%",
//                 transform: `translateX(-${currentSlide * 100}%)`,
//                 transition: "transform 0.4s ease",
//               }}
//             >
//               {cards.map((c) => (
//                 <div
//                   key={c.key}
//                   style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
//                   onClick={() =>
//                     setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)
//                   }
//                 >
//                   <img
//                     src={`${apiurl}/ProgressReport/${c.img}`}
//                     alt="Uploaded"
//                     loading="lazy"
//                     decoding="async"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                       display: "block",
//                     }}
//                     onError={(e) => {
//                       e.currentTarget.style.display = "none";
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>

//             {total > 1 && (
//               <>
//                 <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
//                   <FaChevronLeft size={14} />
//                 </button>
//                 <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
//                   <FaChevronRight size={14} />
//                 </button>
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "10px",
//                     right: "10px",
//                     backgroundColor: "rgba(0,0,0,0.55)",
//                     color: "#fff",
//                     fontSize: "11px",
//                     padding: "2px 8px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   {currentSlide + 1} / {total}
//                 </span>
//               </>
//             )}
//           </div>

//           {/* Dots */}
//           {total > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "6px",
//                 margin: "10px 0 4px",
//               }}
//             >
//               {cards.map((c, i) => (
//                 <span
//                   key={c.key}
//                   onClick={() => setCurrentSlide(i)}
//                   style={{
//                     width: i === currentSlide ? "18px" : "8px",
//                     height: "8px",
//                     borderRadius: "4px",
//                     backgroundColor: i === currentSlide ? theme.border : "#cfd4dc",
//                     cursor: "pointer",
//                     transition: "all 0.3s",
//                   }}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Info */}
//           <div style={{ marginTop: "12px" }}>
//             <InfoRow theme={theme} icon={<TbLocation />} label="Latitude" value={location.latitude || "-"} />
//             <InfoRow theme={theme} icon={<FaMapMarkerAlt />} label="Longitude" value={location.longitude || "-"} />
//             <InfoRow theme={theme} icon={<FaRegCalendarAlt />} label="Date" value={location.date || "-"} />
//             <InfoRow theme={theme} icon={<FaRegClock />} label="Time" value={location.time || "-"} />
//             <InfoRow theme={theme} icon={<FaMountain />} label="Elevation" value={`${location.elevation && location.elevation !== "-" ? location.elevation : ""} m`} />
//             <InfoRow theme={theme} icon={<FaBullseye />} label="Accuracy" value={`${location.accuracy && location.accuracy !== "-" ? location.accuracy : ""} m`} />
//             <InfoRow theme={theme} icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
//           </div>
//         </div>
//       ) : (
//         <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
//           No images found
//         </div>
//       )}

//       <div className="text-center">
//         <button
//           type="button"
//           className="btn btn-primary fw-bold px-5 my-4"
//           onClick={() => setShowSpecific(0)}
//         >
//           Back
//         </button>
//       </div>
//     </div>
//   );
// };

// // 13-10
// const handleBack = () => {
//   // Level 3: deduction details -> back to the Deduction list
//   if (showTable === "deductionDetails") {
//     setShowTable("deduction");
//     setSelectedWorkOrder(null);
//     setDeductionDetails([]);
//      setDeductionDetailsSearchTerm(""); //22-10
//     return;
//   }

//   // Level 2: any other table -> back to dashboard
//   setShowTable("");
// };




//   //4/9/2026
//   return (
//     <>
//    {showSpecific === 1 ? (
 
//   renderPhotoViewer()
// )
//  : showTable === "" ? (
//         <div
//           style={{
//             background: "white",
//             width: "auto",
//             maxHeight: "90vh",
//             transition: "margin-left 0.3s ease",
//             overflowY: "auto",
//             msOverflowStyle: "none",
//             scrollbarWidth: "none",
//             padding: 20,
//             fontFamily: "Inter, sans-serif",
//           }}
//         >
//           <h5
//             style={{
//               fontWeight: 800,
//               marginLeft: 20,
//               marginBottom: 20,
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//             }}
//           >
//             <img
//               src={"/Dashboard-Blue-32.png"}
//               alt="Project Icon"
//               style={{ width: 28, height: 28 }}
//             />
//             Project Dashboard
//           </h5>

//           <div
//             className="pd-filter-section"
//             // style={{
//             //   width: "100%",
//             //   display: "flex",
//             //   alignItems: "center",
//             //   justifyContent: "space-between",
//             //   gap: "35px",
//             //   padding: "20px 28px",
//             //   boxSizing: "border-box",
//             //   flexWrap: "wrap",
//             //   overflow: "visible",
//             //   position: "relative",
//             //   zIndex: 20,
//             // }}
//           >
//             {/* ================= SELECT SCHEME ================= */}
//             <div
//               className="pd-filter-group"
//               // style={{
//               //   flex: "1 1 280px",
//               //   minWidth: "260px",
//               //   display: "flex",
//               //   alignItems: "center",
//               //   gap: "12px",
//               //   boxSizing: "border-box",
//               //   position: "relative",
//               //   zIndex: 30,
//               // }}
//             >
//               <label
//               // className="dropdown-label"
//               // style={{
//               //   margin: 0,
//               //   fontSize: "14px",
//               //   fontWeight: "600",
//               //   color: "#111",
//               //   whiteSpace: "nowrap",
//               //   flexShrink: 0,
//               // }}
//               >
//                 Select Scheme:
//               </label>

//               <div
//                 style={{
//                   flex: "0 1 auto",
//                   minWidth: "150px",
//                   width: "max-content",
//                   maxWidth: "100%",
//                   position: "relative",
//                   zIndex: 100,
//                 }}
//               >
//                 <Select
//                   {...selectCommonProps}
//                   options={[
//                     { value: "Budget", label: "Budget" },
//                     { value: "NonBudget", label: "Non Budget" },
//                   ]}
//                   value={
//                     scheme
//                       ? {
//                           value: scheme,
//                           label:
//                             scheme === "NonBudget" ? "Non Budget" : "Budget",
//                         }
//                       : null
//                   }
//                   onChange={(selectedOption) =>
//                     handleSchemeChange({
//                       target: {
//                         name: "scheme",
//                         value: selectedOption ? selectedOption.value : "",
//                       },
//                     })
//                   }
//                   placeholder="Search / Choose Scheme"
//                   isSearchable
//                   isClearable
//                   menuPortalTarget={document.body}
//                   menuPosition="fixed"
//                   styles={{
//                     ...selectCommonProps?.styles,

//                     container: (provided) => ({
//                       ...provided,
//                       width: "100%",
//                       minWidth: "150px",
//                     }),

//                     control: (provided, state) => ({
//                       ...provided,
//                       minHeight: "42px",
//                       height: "42px",
//                       minWidth: "150px",
//                       width: "max-content",
//                       maxWidth: "260px",
//                       borderRadius: "7px",
//                       borderColor: state.isFocused ? "#2684ff" : "#cfd4dc",
//                       boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
//                       cursor: "pointer",
//                       backgroundColor: "#fff",
//                     }),

//                     valueContainer: (provided) => ({
//                       ...provided,
//                       padding: "2px 10px",
//                       whiteSpace: "nowrap",
//                     }),

//                     singleValue: (provided) => ({
//                       ...provided,
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       maxWidth: "180px",
//                       color: "#222",
//                       fontSize: "14px",
//                     }),

//                     placeholder: (provided) => ({
//                       ...provided,
//                       whiteSpace: "nowrap",
//                       color: "#777",
//                       fontSize: "14px",
//                     }),

//                     menu: (provided) => ({
//                       ...provided,
//                       zIndex: 99999,
//                       minWidth: "180px",
//                       width: "max-content",
//                       maxWidth: "300px",
//                     }),

//                     menuPortal: (provided) => ({
//                       ...provided,
//                       zIndex: 99999,
//                     }),

//                     option: (provided, state) => ({
//                       ...provided,
//                       fontSize: "14px",
//                       whiteSpace: "nowrap",
//                       backgroundColor: state.isSelected
//                         ? "#0d6efd"
//                         : state.isFocused
//                           ? "#eaf3ff"
//                           : "#fff",
//                       color: state.isSelected ? "#fff" : "#222",
//                       cursor: "pointer",
//                     }),
//                   }}
//                 />
//               </div>
//             </div>

//             {/* ================= SELECT HEAD ================= */}
//             {scheme === "Budget" && (
//               <div
//                 className="pd-filter-group"
//                 // style={{
//                 //   flex: "1 1 280px",
//                 //   minWidth: "260px",
//                 //   display: "flex",
//                 //   alignItems: "center",
//                 //   gap: "12px",
//                 //   boxSizing: "border-box",
//                 //   position: "relative",
//                 //   zIndex: 30,
//                 // }}
//               >
//                 <label
//                 // className="dropdown-label"
//                 // style={{
//                 //   margin: 0,
//                 //   fontSize: "14px",
//                 //   fontWeight: "600",
//                 //   color: "#111",
//                 //   whiteSpace: "nowrap",
//                 //   flexShrink: 0,
//                 // }}
//                 >
//                   Select Head:
//                 </label>

//                 <div
//                   style={{
//                     flex: "0 1 auto",
//                     minWidth: "150px",
//                     width: "max-content",
//                     maxWidth: "100%",
//                     position: "relative",
//                     zIndex: 100,
//                   }}
//                 >
//                   <Select
//                     {...selectCommonProps}
//                     // options={headFetchedData.map((head) => ({
//                     //   value: head.HeadID,
//                     //   label: head.HeadName || head.BudgetHead,
//                     // }))}
//                     // value={
//                     //   headFetchedData
//                     //     .map((head) => ({
//                     //       value: head.HeadID,
//                     //       label: head.HeadName || head.BudgetHead,
//                     //     }))
//                     //     .find((option) => option.value === headId) || null
//                     // }
//                     options={headOptions}
//                     value={selectedHeadOption}
//                     // onChange={(selectedOption) =>
//                     //   handleHeadChange({
//                     //     target: {
//                     //       name: "HeadName",
//                     //       value: selectedOption ? selectedOption.value : "",
//                     //     },
//                     //   })
//                     // }
//                     onChange={(selectedOption) =>
//                       handleHeadChange({
//                         target: {
//                           name: "HeadName",
//                           value: selectedOption
//                             ? String(selectedOption.value)
//                             : "",
//                         },
//                       })
//                     }
//                     placeholder="Search / Choose Head"
//                     isSearchable
//                     isClearable
//                     noOptionsMessage={() => "No head found"}
//                     menuPortalTarget={document.body}
//                     menuPosition="fixed"
//                     styles={{
//                       ...selectCommonProps?.styles,

//                       container: (provided) => ({
//                         ...provided,
//                         width: "100%",
//                         minWidth: "150px",
//                       }),

//                       control: (provided, state) => ({
//                         ...provided,
//                         minHeight: "42px",
//                         height: "42px",
//                         minWidth: "150px",
//                         width: "max-content",
//                         maxWidth: "300px",
//                         borderRadius: "7px",
//                         borderColor: state.isFocused ? "#2684ff" : "#cfd4dc",
//                         boxShadow: state.isFocused
//                           ? "0 0 0 1px #2684ff"
//                           : "none",
//                         cursor: "pointer",
//                         backgroundColor: "#fff",
//                       }),

//                       valueContainer: (provided) => ({
//                         ...provided,
//                         padding: "2px 10px",
//                         whiteSpace: "nowrap",
//                       }),

//                       singleValue: (provided) => ({
//                         ...provided,
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         maxWidth: "220px",
//                         color: "#222",
//                         fontSize: "14px",
//                       }),

//                       placeholder: (provided) => ({
//                         ...provided,
//                         whiteSpace: "nowrap",
//                         color: "#777",
//                         fontSize: "14px",
//                       }),

//                       menu: (provided) => ({
//                         ...provided,
//                         zIndex: 99999,
//                         minWidth: "200px",
//                         width: "max-content",
//                         maxWidth: "350px",
//                       }),

//                       menuPortal: (provided) => ({
//                         ...provided,
//                         zIndex: 99999,
//                       }),

//                       option: (provided, state) => ({
//                         ...provided,
//                         fontSize: "14px",
//                         whiteSpace: "nowrap",
//                         backgroundColor: state.isSelected
//                           ? "#0d6efd"
//                           : state.isFocused
//                             ? "#eaf3ff"
//                             : "#fff",
//                         color: state.isSelected ? "#fff" : "#222",
//                         cursor: "pointer",
//                       }),
//                     }}
//                   />
//                 </div>
//               </div>
//             )}

//             {/* ================= SELECT PROJECT ================= */}
//             <div  className="pd-filter-group" >
//               <label >  Select Project: </label>
//               <div
//                 style={{
//                   flex: "0 1 auto",
//                   minWidth: "150px",
//                   width: "max-content",
//                   maxWidth: "100%",
//                   position: "relative",
//                   zIndex: 100,
//                 }}
//               >
//                 <Select
//                   {...selectCommonProps}
//                   options={searchedProjects.map((p) => ({
//                     value: p.ProjectId,
//                     label: p.ProjectName,
//                   }))}
//                   name="projectId"
//                   value={
//                     searchedProjects
//                       .map((p) => ({
//                         value: p.ProjectId,
//                         label: p.ProjectName,
//                       }))
//                       .find((option) => option.value === projectId) || null
//                   }
//                   onChange={(selectedOption) => {
//                     handleProjectChange({
//                       target: {
//                         name: "projectId",
//                         value: selectedOption ? selectedOption.value : "",
//                       },
//                     });
//                   }}
//                   placeholder="Search / Choose Project"
//                   isSearchable={true}
//                   isClearable={true}
//                   noOptionsMessage={() => "No project found"}
//                   menuPortalTarget={document.body}
//                   menuPosition="fixed"
//                   styles={{
//                     ...selectCommonProps?.styles,

//                     container: (provided) => ({
//                       ...provided,
//                       width: "100%",
//                       minWidth: "150px",
//                     }),

//                     control: (provided, state) => ({
//                       ...provided,
//                       minHeight: "42px",
//                       height: "42px",
//                       minWidth: "150px",
//                       width: "max-content",
//                       maxWidth: "320px",
//                       borderRadius: "7px",
//                       borderColor: state.isFocused ? "#2684ff" : "#cfd4dc",
//                       boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
//                       cursor: "pointer",
//                       backgroundColor: "#fff",
//                     }),

//                     valueContainer: (provided) => ({
//                       ...provided,
//                       padding: "2px 10px",
//                       whiteSpace: "nowrap",
//                     }),

//                     singleValue: (provided) => ({
//                       ...provided,
//                       whiteSpace: "nowrap",
//                       overflow: "hidden",
//                       textOverflow: "ellipsis",
//                       maxWidth: "240px",
//                       color: "#222",
//                       fontSize: "14px",
//                     }),

//                     placeholder: (provided) => ({
//                       ...provided,
//                       whiteSpace: "nowrap",
//                       color: "#777",
//                       fontSize: "14px",
//                     }),

//                     menu: (provided) => ({
//                       ...provided,
//                       zIndex: 99999,
//                       minWidth: "220px",
//                       width: "max-content",
//                       maxWidth: "400px",
//                     }),

//                     menuPortal: (provided) => ({
//                       ...provided,
//                       zIndex: 99999,
//                     }),

//                     option: (provided, state) => ({
//                       ...provided,
//                       fontSize: "14px",
//                       whiteSpace: "nowrap",
//                       backgroundColor: state.isSelected
//                         ? "#0d6efd"
//                         : state.isFocused
//                           ? "#eaf3ff"
//                           : "#fff",
//                       color: state.isSelected ? "#fff" : "#222",
//                       cursor: "pointer",
//                     }),
//                   }}
//                 />
//               </div>
//             </div>
//           </div>
//           {loading ? (
//             <div className="Adminloader"></div>
//           ) : (
//             <>
//               {/* Top Cards */}
//               <div className="dashboard-summary-grid">
//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                     {/* <img src={TotalProjectCost} alt="total project cost" /> */}
//                     <img src={"/Total-Project.png"} alt="Total Project Cost" />
//                   </div>
//                   <div className="summary-card-content">
//                     <h6>Total Project Cost</h6>
//                     <h3 style={{ margin: 0, fontWeight: 700 }}>
//                       ₹{" "}
//                       {Number(
//                         projectId
//                           ? displayData.Project_Cost
//                           : schemeProjectCost,
//                       ).toLocaleString("en-IN")}
//                     </h3>
//                   </div>
//                   <div
//                     onClick={() => setShowTable("project")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>


//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                    <img  src={"/Total-Limit-Allocation.png"}  />
//                   </div>
//                   <div className="summary-card-content">
//                     <h5 style={{ margin: 0, fontSize: 15 }}>
//                       Total Limit Allocation
//                     </h5>
//                     <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>
//                       {/* ₹{" "}
//                       {Number(
//                         displayData.ReleaseAmountTillDate || 0,
//                       ).toLocaleString("en-IN")} */}
//                       ₹{" "}
//                       {Number(
//                         projectId
//                           ? totalLimitAllocationAmount
//                           : displayData.ReleaseAmountTillDate || 0,
//                       ).toLocaleString("en-IN")}
//                     </h3>
//                   </div>
//                   <div
//                     onClick={() => setShowTable("limitAllocation")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>

//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                     {/* c:\Users\Softm\Downloads\Liability Register System - Icons & Images\100 Size\Project Dashboard\Total-Work-Orders-100.png */}
//                       <img src={"/Total-Work-Orders-100.png"} />
//                   </div>
//                   <div className="summary-card-content">
//                     <h5 style={{ margin: 0, fontSize: 15 }}>
//                       Total Work Orders
//                     </h5>
//                     <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>
//                       {Number(displayData.TotalWorkOrders).toLocaleString(
//                         "en-IN",
//                       )}
//                     </h3>
//                   </div>
//                   <div
//                     onClick={() => setShowTable("workOrder")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>

//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                     <img
//                       src={"/Total-Progress-Report-100.png"}
//                       // replace with your ProgressReport icon if available
//                       style={{ width: 50, height: 50, marginRight: 15 }}
//                       alt="Progress Report"
//                     />
//                   </div>
//                   <div className="summary-card-content">
//                     <h5 style={{ margin: 0, fontSize: 15 }}>
//                       Total Progress Report
//                     </h5>
//                     <h3 style={{ margin: 0, fontWeight: 700 }}>
//                       {progressTableData.length}
//                     </h3>
//                   </div>
//                   <div
//                     onClick={() => setShowTable("progress")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>

//               </div>

//               <div className="dashboard-budget-extra-cards">
//                 {scheme === "Budget" && (
//                   <div className="summary-card">
//                     <div className="summary-card-icon">
//                      <img src="/MIS-Total-Number-Of-Vendor.png" alt="Total Heads Assign"/>
//                     </div>
//                     <div className="summary-card-content">
//                       <h6>Total Heads Assigns</h6>
//                       <h6 style={{ margin: 0, fontWeight: 600 }}>
//                         {/* {Number(
//                           displayData.TotalBudgetHeads || 0,
//                         ).toLocaleString("en-IN")} */}
//                         {/* {Number(
//       projectId
//         ? headDetailsTableData.length
//         : displayData.TotalBudgetHeads || 0,
//     ).toLocaleString("en-IN")} */}
//                         {Number(headsAssignsCount).toLocaleString("en-IN")}
//                       </h6>
//                     </div>
//                     <div
//                       onClick={() => {
//                         setShowTable("head");
//                         loadHeadTable();
//                       }}
//                       style={{ marginLeft: "auto", cursor: "pointer" }}
//                     >
//                       <img
//                         src="/Arrow64.png"
//                         alt="arrow"
//                         style={{ width: 30, height: 30 }}
//                       />
//                     </div>
//                   </div>
//                 )}

//                 {scheme === "Budget" && (
//                   <div className="summary-card">
//                     <div className="summary-card-icon">
//                       <img src='/Total-Estimate-Amount.png' />
//                     </div>
//                     <div className="summary-card-content">
//                       <h6>Total Estimate Amount</h6>
//                       <h6 style={{ margin: 0, fontWeight: "600" }}>
//                         ₹{" "}
//                         {Number(
//                           displayData.Esitmate_Amount ??
//                             getData.Esitmate_Amount ??
//                             0,
//                         ).toLocaleString("en-IN")}
//                       </h6>
//                     </div>
//                     <div
//                       onClick={() => setShowTable("estimate")}
//                       style={{ marginLeft: "auto", cursor: "pointer" }}
//                     >
//                       <img
//                         src="/Arrow64.png"
//                         alt="arrow"
//                         style={{ width: 30, height: 30 }}
//                       />
//                     </div>
//                   </div>
//                 )}


//                 {/* 14-10 for UI changse */}
//                 {scheme === "Budget" && (
//   <div className="summary-card">
//     <div className="summary-card-icon">
//       <img src="/Total%20bill%20amt%20100%20Size.png" alt="Total Bill Generation" />
//     </div>
//     <div className="summary-card-content">
//       <h6>Total Bill Generation Amount</h6>
//       <h3 style={{ margin: 0, fontWeight: 700, fontSize: "16px" }}>
//         ₹ {Number(displayData.LiabalityAmount || 0).toLocaleString("en-IN")}
//       </h3>
//     </div>
//     <div onClick={() => setShowTable("demand")} style={{ marginLeft: "auto", cursor: "pointer" }}>
//       <img src="/Arrow64.png" alt="arrow" style={{ width: 30, height: 30 }} />
//     </div>
//   </div>
// )}

// {scheme === "Budget" && (
//   <div className="summary-card">
//     <div className="summary-card-icon">
//       <img src="/Total-Deduction-Amount.png" alt="Total Deduction" />
//     </div>
//     <div className="summary-card-content">
//       <h6>Total Deduction Amount</h6>
//       <h3 style={{ margin: 0, fontWeight: 700, fontSize: "16px" }}>
//         ₹ {Number(displayData.TotalDeductionAmount || 0).toLocaleString("en-IN")}
//       </h3>
//     </div>
//     <div onClick={() => setShowTable("deduction")} style={{ marginLeft: "auto", cursor: "pointer" }}>
//       <img src="/Arrow64.png" alt="arrow" style={{ width: 30, height: 30 }} />
//     </div>
//   </div>
// )}
//               </div>

//               {/* Charts Row */}
//               <div
//                 className="dashboard-charts-grid"
//                 style={{
//                   width: "100%",
//                   display: "grid",
//                    // 14-10 for UI
//                   gridTemplateColumns:
//   scheme === "Budget"
//     ? "minmax(0, 1.8fr) minmax(280px, 1fr)"
//     : "minmax(0, 1.65fr) minmax(250px, 0.9fr) minmax(220px, 0.65fr)",
//                   gap: "14px",
//                   alignItems: "stretch",
//                   boxSizing: "border-box",
//                   overflow: "hidden",
//                 }}
//               >
//                 {/* ========================================================= */}
//                 {/* TOTAL SPEND */}
//                 {/* ========================================================= */}

//                 <div
//                   style={{
//                     width: "100%",
//                     minWidth: 0,
//                     maxWidth: "100%",
//                     boxSizing: "border-box",
//                     background: "#ffffff",
//                     borderRadius: "14px",
//                     padding: "20px",
//                     overflow: "hidden",
//                     ...cardChartStyle,
//                   }}
//                 >
//                   <h5
//                     style={{
//                       margin: "0 0 15px 0",
//                       fontSize: "16px",
//                       fontWeight: "600",
//                     }}
//                   >
//                     Total Spend
//                   </h5>

//                   <div
//                     style={{
//                       width: "100%",
//                       minWidth: 0,
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "10px",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     {/* ================= LEFT SUMMARY ================= */}

//                     <div
//                       style={{
//                         width: "30%",
//                         minWidth: "125px",
//                         maxWidth: "180px",
//                         flexShrink: 0,
//                         boxSizing: "border-box",
//                       }}
//                     >
//                       <h1
//                         style={{
//                           margin: 0,
//                           fontSize: "36px",
//                           lineHeight: "1.1",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         ₹37.5K
//                       </h1>

//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "8px",
//                           marginTop: "8px",
//                         }}
//                       >
//                         <p
//                           style={{
//                             color: "darkgray",
//                             margin: 0,
//                             fontSize: "14px",
//                             lineHeight: "1.3",
//                           }}
//                         >
//                           Total
//                           <br />
//                           Spend
//                         </p>

//                         <p
//                           style={{
//                             color: "#01b574",
//                             fontWeight: 700,
//                             margin: 0,
//                             fontSize: "13px",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           +2.45%
//                         </p>
//                       </div>

//                       <h4
//                         style={{
//                           color: "#01b574",
//                           fontWeight: 700,
//                           margin: "8px 0 0 0",
//                           fontSize: "15px",
//                         }}
//                       >
//                         On track
//                       </h4>
//                     </div>

//                     {/* ================= AREA CHART ================= */}

//                     <div
//                       id="chart"
//                       style={{
//                         flex: "1 1 70%",
//                         width: "70%",
//                         minWidth: 0,
//                         maxWidth: "100%",
//                         overflow: "hidden",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         boxSizing: "border-box",
//                       }}
//                     >
//                       <div
//                         style={{
//                           width: "100%",
//                           minWidth: 0,
//                           maxWidth: "100%",
//                           overflow: "hidden",
//                         }}
//                       >
//                         <ReactApexChart
//                           options={{
//                             ...state.options,

//                             chart: {
//                               ...state.options.chart,
//                               type: "area",
//                               width: "100%",
//                               parentHeightOffset: 0,
//                               toolbar: {
//                                 show: false,
//                               },
//                             },

//                             stroke: {
//                               width: [4, 4],
//                               curve: "straight",
//                             },

//                             colors: ["#7f47dd", "#38d1bd"],

//                             fill: {
//                               type: "gradient",
//                               gradient: {
//                                 shade: "light",
//                                 type: "vertical",
//                                 shadeIntensity: 0.4,
//                                 gradientToColors: ["#ffffff", "#ffffff"],
//                                 inverseColors: false,
//                                 opacityFrom: 0.6,
//                                 opacityTo: 0,
//                                 stops: [0, 100],
//                               },
//                             },

//                             dataLabels: {
//                               enabled: false,
//                             },

//                             dropShadow: {
//                               enabled: true,
//                               top: 8,
//                               blur: 6,
//                               opacity: 0.3,
//                               color: "#7f47dd",
//                             },

//                             grid: {
//                               borderColor: "#e0e0e0",
//                               strokeDashArray: 4,
//                             },

//                             markers: {
//                               size: 4,
//                               colors: ["#fff"],
//                               strokeColors: ["#7f47dd", "#38d1bd"],
//                               strokeWidth: 2,
//                             },

//                             legend: {
//                               position: "top",
//                               horizontalAlign: "center",
//                               fontSize: "12px",
//                               labels: {
//                                 colors: "#333",
//                               },
//                             },

//                             responsive: [
//                               {
//                                 breakpoint: 1200,
//                                 options: {
//                                   legend: {
//                                     fontSize: "11px",
//                                   },
//                                 },
//                               },
//                             ],
//                           }}
//                           series={state.series}
//                           type="area"
//                           height={300}
//                           width="100%"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* ========================================================= */}
//                 {/* TAXES AND AMOUNTS */}
//                 {/* ========================================================= */}
//                 <div className="dashboard-chart-card taxes-card">
//                   {" "}
//                   <div className="chart-card-header">
//                     {" "}
//                     <h5
//                       style={{ margin: 0, fontSize: "16px", fontWeight: "600" }}
//                     >
//                       {" "}
//                       Taxes And Amounts{" "}
//                     </h5>{" "}
//                   </div>{" "}
//                   {/* <div className="tax-chart">
//                     {" "}
//                     <ReactApexChart
//                       options={
//                         deductionData && deductionData.length > 0
//                           ? state5.options
//                           : state4.options
//                       }
//                       series={
//                         deductionData && deductionData.length > 0
//                           ? state5.series
//                           : state4.series
//                       }
//                       type="donut"
//                       width={280}
//                     />{" "}
//                   </div>{" "} */}
//                   <div className="tax-chart">
//                     {(
//                       deductionData?.length > 0
//                         ? state5.series.some((v) => v > 0)
//                         : state4.series.some((v) => v > 0)
//                     ) ? (
//                       <ReactApexChart
//                         options={
//                           deductionData && deductionData.length > 0
//                             ? state5.options
//                             : state4.options
//                         }
//                         series={
//                           deductionData && deductionData.length > 0
//                             ? state5.series
//                             : state4.series
//                         }
//                         type="donut"
//                         width={280}
//                       />
//                     ) : (
//                       <div
//                         style={{
//                           textAlign: "center",
//                           padding: "40px 0",
//                           color: "#999",
//                         }}
//                       >
//                         No data to display
//                       </div>
//                     )}
//                   </div>
//                 </div>

//                 {/* ========================================================= */}
//                 {/* RIGHT SIDE CARDS */}
//                 {/* ========================================================= */}
// {scheme !== "Budget" && (
//                 <div
//                   className="dashboard-right-cards"
//                   style={{
//                     width: "100%",
//                     minWidth: 0,
//                     maxWidth: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: "14px",
//                     boxSizing: "border-box",
//                     overflow: "hidden",
//                   }}
//                 >
//                   {/* ================= BILL GENERATION ================= */}
//                    {scheme !== "Budget" && (
//                   <div className="dashboard-right-cards">
//                     <div
//                       className="dashboard-right-card"
//                       // style={{
//                       //   width: "100%",
//                       //   minWidth: 0,
//                       //   boxSizing: "border-box",
//                       //   display: "flex",
//                       //   alignItems: "center",
//                       //   gap: "10px",
//                       //   padding: "18px",
//                       //   borderRadius: "12px",
//                       //   overflow: "hidden",
//                       // }}
//                     >
//                       <div className="right-card-top-row">
//                         <div
//                           className="dashboard-right-card-icon"
//                           // style={{
//                           //   flexShrink: 0,
//                           // }}
//                         >
//                           <img  src={"/Total%20bill%20amt%20100%20Size.png"}  alt="Total Bill Generation" />
//                         </div>

//                         <div
//                           className="dashboard-right-card-content"
//                           // style={{
//                           //   minWidth: 0,
//                           //   flex: 1,
//                           //   overflow: "hidden",
//                           // }}
//                         >
//                           <h5
//                           // style={{
//                           //   margin: 0,
//                           //   fontSize: "13px",
//                           //   fontWeight: "600",
//                           //   lineHeight: "1.3",
//                           //   wordBreak: "break-word",
//                           // }}
//                           >
//                             Total Bill Generation Amount
//                           </h5>

//                           <h3
//                           // style={{
//                           //   margin: "7px 0 0 0",
//                           //   fontSize: "16px",
//                           //   whiteSpace: "nowrap",
//                           // }}
//                           >
//                             ₹{" "}
//                             {Number(
//                               displayData.LiabalityAmount || 0,
//                             ).toLocaleString("en-IN")}
//                           </h3>
//                         </div>

//                         <div
//                           onClick={() => setShowTable("demand")}
//                           className="right-card-arrow-badge"
//                           // style={{
//                           //   flexShrink: 0,
//                           //   cursor: "pointer",
//                           //   marginLeft: "auto",
//                           // }}
//                         >
//                           <img
//                             src="/Arrow64.png"
//                             alt="arrow"
//                             // style={{
//                             //   width: "28px",
//                             //   height: "28px",
//                             // }}
//                           />
//                         </div>
//                       </div>
//                     </div>

//                     {/* ================= DEDUCTION ================= */}

//                     <div
//                       className="dashboard-right-card"
//                       // style={{
//                       //   width: "100%",
//                       //   minWidth: 0,
//                       //   boxSizing: "border-box",
//                       //   display: "flex",
//                       //   alignItems: "center",
//                       //   gap: "10px",
//                       //   padding: "18px",
//                       //   borderRadius: "12px",
//                       //   overflow: "hidden",
//                       // }}
//                     >
//                       <div className="right-card-top-row">
//                         <div
//                           className="dashboard-right-card-icon"
//                           // style={{
//                           //   flexShrink: 0,
//                           // }}
//                         >
//                           <img   src={"/Total-Deduction-Amount.png"} alt="Total Deduction" />
//                         </div>

//                         <div
//                           className="dashboard-right-card-content"
//                           // style={{
//                           //   minWidth: 0,
//                           //   flex: 1,
//                           //   overflow: "hidden",
//                           // }}
//                         >
//                           <h5
//                           // style={{
//                           //   margin: 0,
//                           //   fontSize: "13px",
//                           //   fontWeight: "600",
//                           //   lineHeight: "1.3",
//                           //   wordBreak: "break-word",
//                           // }}
//                           >
//                             Total Deduction Amount
//                           </h5>

//                           <h3
//                           // style={{
//                           //   margin: "7px 0 0 0",
//                           //   fontSize: "16px",
//                           //   whiteSpace: "nowrap",
//                           // }}
//                           >
//                             ₹{" "}
//                             {Number(
//                               displayData.TotalDeductionAmount || 0,
//                             ).toLocaleString("en-IN")}
//                           </h3>
//                         </div>

//                         <div
//                           className="right-card-arrow-badge"
//                           onClick={() => setShowTable("deduction")}
//                           // style={{
//                           //   flexShrink: 0,
//                           //   cursor: "pointer",
//                           //   marginLeft: "auto",
//                           // }}
//                         >
//                           <img
//                             src="/Arrow64.png"
//                             alt="arrow"
//                             // style={{
//                             //   width: "28px",
//                             //   height: "28px",
//                             // }}
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                    )}
//                 </div>
// )}
//               </div>

//               {/* ================= VENDOR BILLS + HEAD DETAILS ================= */}
//               <div className="vendor-head-container">
//                 {/* ================= VENDOR BILLS ================= */}
//                 <div className="vendor-bills-card">
//                   <div className="dashboard-table-header">
//                     <h4 className="dashboard-table-title">Vendor Bills</h4>
//                   </div>

//                   <div
//                     className="dashboard-table-wrapper"
//                     style={{
//                       overflowX: "auto",
//                       overflowY: "hidden",
//                       width: "100%",
//                     }}
//                   >
//                     <table
//                       className="dashboard-table"
//                       style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                       }}
//                     >
//                       <thead>
//                         <tr>
//                           <th
//                             style={{
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               textAlign:"center"
//                             }}
//                           >
//                             Bill Number
//                           </th>

//                           <th
//                             style={{
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               textAlign:"center"
//                             }}
//                           >
//                             Name
//                           </th>

//                           <th
//                             style={{
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               textAlign:"center"
//                             }}
//                           >
//                             Status
//                           </th>

//                           <th
//                             style={{
//                               whiteSpace: "nowrap",
//                               textAlign:"center"
//                             }}
//                           >
//                             Date
//                           </th>

//                           <th
//                             style={{
//                               whiteSpace: "nowrap",
//                               textAlign:"center"
//                             }}
//                           >
//                             Progress
//                           </th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentBills.length < 1 ? (
//                           <tr>
//                               {/* <td
//                                 colSpan="5"
//                                 style={{
//                                   textAlign: "center",
//                                   padding: "15px",
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 No Bills Found
//                               </td> */}
//                           </tr>
//                         ) : (
//                           currentBills.map((bill, index) => (
//                             <tr key={index}>
//                               {/* ================= BILL NUMBER ================= */}
//                               <td
//                                 style={{
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                 }}
//                               >
//                                 {bill.BillNumber}
//                               </td>

//                               {/* ================= VENDOR NAME ================= */}
//                               <td
//                                 style={{
//                                   maxWidth: "180px",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                   whiteSpace: "nowrap",
//                                 }}
//                                 title={bill.Vendor_Company_Name || ""}
//                               >
//                                 {bill.Vendor_Company_Name}
//                               </td>

//                               {/* ================= STATUS ================= */}
//                               <td
//                                 style={{
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                 }}
//                               >
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     gap: "6px",
//                                     minWidth: 0,
//                                     whiteSpace: "nowrap",
//                                   }}
//                                 >
//                                   <img
//                                     src={
//                                       bill.Status === "Sent to Bank" ||
//                                       bill.Status === "Successful/Paid"
//                                         ? Approved32
//                                         : Disable32
//                                     }
//                                     alt=""
//                                     style={{
//                                       width: "16px",
//                                       height: "16px",
//                                       minWidth: "16px",
//                                       flexShrink: 0,
//                                       objectFit: "contain",
//                                     }}
//                                   />

//                                   <span
//                                     style={{
//                                       display: "block",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       whiteSpace: "nowrap",
//                                     }}
//                                     title={
//                                       bill.Status === "false"
//                                         ? "Approvals Pending"
//                                         : bill.Status || ""
//                                     }
//                                   >
//                                     {bill.Status === "false"
//                                       ? "Approvals Pending"
//                                       : bill.Status}
//                                   </span>
//                                 </div>
//                               </td>

//                               {/* ================= DATE ================= */}
//                               <td
//                                 style={{
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 {bill.UploadedOn?.slice(0, 10)}
//                               </td>

//                               {/* ================= PROGRESS ================= */}
//                               <td
//                                 style={{
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 <div
//                                   className="progress-bar"
//                                   style={{
//                                     overflow: "hidden",
//                                   }}
//                                 >
//                                   <div
//                                     className="progress"
//                                     style={{
//                                       width: "50%",
//                                     }}
//                                   ></div>
//                                 </div>
//                               </td>
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </table>

//                     {/* 02-10 add no data msg */}
//                     {currentBills.length < 1 && (
//   <div
//     style={{
//       position: "sticky",
//       left: 0,
//       width: "100%",
//       textAlign: "center",
//       padding: "20px 15px",
//       color: "#777",
//       fontSize: "14px",
//       boxSizing: "border-box",
//       marginBottom:"30px"
//     }}
//   >
//     No Bills Found
//   </div>
// )}
 
//                   </div>

//                   {/* ================= VENDOR PAGINATION ================= */}
//                   <div
//                     style={{
//                       width: "100%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       marginTop: "15px",
//                       padding: "10px 0",
//                     }}
//                   >
//                     {/* Showing Entries */}
//                     <p
//                       style={{
//                         margin: 0,
//                         fontSize: "13px",
//                         color: "#333",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {/* Showing{" "}
//                    {vendorbills.length === 0
//                      ? 0
//                      : indexOfFirstBill + 1}{" "}
//                    to{" "}
//                    {Math.min(
//                      indexOfLastBill,
//                      vendorbills.length
//                    )}{" "}
//                    of {vendorbills.length} entries
//                  </p> */}
//                     </p>
//                     {/* Pagination */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "18px",
//                       }}
//                     >
//                       {/* Previous */}
//                       <button
//                         onClick={() =>
//                           setCurrentPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={currentPage === 1}
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                           fontSize: "12px",
//                           padding: 0,
//                           opacity: currentPage === 1 ? 0.5 : 1,
//                         }}
//                       >
//                         ‹ Previous
//                       </button>
//                       {/* Page Numbers */}
//                       {/* Page Numbers */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "20px",
//                         }}
//                       >
//                         {getPageNumbers(currentPage, totalPages).map(
//                           (pageNumber, index) =>
//                             pageNumber === "..." ? (
//                               <span
//                                 key={`vendor-ellipsis-${index}`}
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#444",
//                                 }}
//                               >
//                                 ...
//                               </span>
//                             ) : (
//                               <button
//                                 key={pageNumber}
//                                 onClick={() => setCurrentPage(pageNumber)}
//                                 style={{
//                                   border: "none",
//                                   background: "transparent",
//                                   padding: 0,
//                                   color:
//                                     currentPage === pageNumber
//                                       ? "#2ea4e7"
//                                       : "#444",
//                                   cursor: "pointer",
//                                   fontSize: "13px",
//                                   fontWeight:
//                                     currentPage === pageNumber ? "600" : "400",
//                                   textDecoration:
//                                     currentPage === pageNumber
//                                       ? "underline"
//                                       : "none",
//                                 }}
//                               >
//                                 {pageNumber}
//                               </button>
//                             ),
//                         )}
//                       </div>

//                       {/* Next */}
//                       <button
//                         onClick={() =>
//                           setCurrentPage((prev) =>
//                             Math.min(prev + 1, totalPages),
//                           )
//                         }
//                         disabled={
//                           currentPage === totalPages || totalPages === 0
//                         }
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor:
//                             currentPage === totalPages || totalPages === 0
//                               ? "not-allowed"
//                               : "pointer",
//                           fontSize: "12px",
//                           padding: 0,
//                           opacity:
//                             currentPage === totalPages || totalPages === 0
//                               ? 0.5
//                               : 1,
//                         }}
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* ================= HEAD DETAILS ================= */}
//                 <div className="head-details-card"
//                 // 05-10
//   style={{
//     height: "350px",
//     minHeight: 0,
//     overflow: "hidden",
//     display: "flex",
//     flexDirection: "column",
//   }}>
//                   {/* ================= HEADER ================= */}
//                   <div className="dashboard-table-header">
//                     <h4 className="dashboard-table-title">Head Details</h4>
//                   </div>

//                   {/* ================= TABLE ================= */}
//                   <div
//                     // className="dashboard-table-wrapper"
//                     // style={{
//                     //   width: "100%",
//                     //   height: "100%",
//                     //   overflowX: "auto",
//                     //   overflowY: "hidden",
//                     //   boxSizing: "border-box",
//                     // }}
//                     // 05-10
//                     className="dashboard-table-wrapper"
//   style={{width: "100%", flex: "1 1 auto", minHeight: 0, overflowX: "auto", overflowY: "auto", boxSizing: "border-box",}}
//                   >
//                     <table
//                       className="dashboard-table head-table"
//                       // style={{
//                       //   width: "100%",
//                       //   borderCollapse: "collapse",
//                       //   tableLayout: "fixed",
//                       // }}
//                       // 05-10
//                       style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         tableLayout: "fixed",
//                       }}
//                     >
//                       <thead>
//                         <tr>
//                           {/* SR NO */}
//                           <th
//                             style={{
//                               width: "18%",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               boxSizing: "border-box",
//                               textAlign:"center"
//                             }}
//                           >
//                             Sr. No
//                           </th>

//                           {/* BUDGET HEAD */}
//                           <th
//                             style={{
//                               width: "47%",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               textAlign: "center",
//                               boxSizing: "border-box",
//                             }}
//                           >
//                             Budget Head
//                           </th>

//                           {/* AMOUNT */}
//                           <th
//                             style={{
//                               width: "35%",
//                               whiteSpace: "nowrap",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               textAlign: "center",
//                               boxSizing: "border-box",
//                             }}
//                           >
//                             Amount
//                           </th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentHeads && currentHeads.length > 0 ? (
//                           currentHeads.map(
//                             ([budgetHead, totalAmount], index) => (
//                               <tr key={index}>
//                                 {/* ================= SR NO ================= */}
//                                 <td
//                                   style={{
//                                     width: "18%",
//                                     whiteSpace: "nowrap",
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     textAlign: "left",
//                                     verticalAlign: "middle",
//                                     boxSizing: "border-box",
//                                   }}
//                                 >
//                                   {headIndexOfFirst + index + 1}
//                                 </td>

//                                 {/* ================= BUDGET HEAD ================= */}
//                                 <td
//                                   style={{
//                                     width: "47%",
//                                     maxWidth: "47%",
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     whiteSpace: "nowrap",
//                                     textAlign: "left",
//                                     verticalAlign: "middle",
//                                     boxSizing: "border-box",
//                                   }}
//                                   title={budgetHead || ""}
//                                 >
//                                   <div
//                                     style={{
//                                       width: "100%",
//                                       overflow: "hidden",
//                                       textOverflow: "ellipsis",
//                                       whiteSpace: "nowrap",
//                                     }}
//                                   >
//                                     {/* {HeadName || "-"} */}
//                                     {budgetHead}
//                                   </div>
//                                 </td>

//                                 {/* ================= AMOUNT ================= */}
//                                 <td
//                                   style={{
//                                     width: "35%",
//                                     whiteSpace: "nowrap",
//                                     overflow: "hidden",
//                                     textOverflow: "ellipsis",
//                                     textAlign: "right",
//                                     verticalAlign: "middle",
//                                     boxSizing: "border-box",
//                                   }}
//                                   title={`₹ ${Number(
//                                     totalAmount || 0,
//                                   ).toLocaleString("en-IN")}`}
//                                 >
//                                   ₹{" "}
//                                   {Number(totalAmount || 0).toLocaleString(
//                                     "en-IN",
//                                   )}
//                                 </td>
//                               </tr>
//                             ),
//                           )
//                         ) : (
//                           <tr>
//                             <td
//                               colSpan="3"
//                               style={{
//                                 textAlign: "center",
//                                 padding: "15px",
//                                 whiteSpace: "nowrap",
//                               }}
//                             >
//                               No Data Found
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>

//                   {/* ================= HEAD PAGINATION ================= */}
//                   <div
//                     className="project-pagination"
//                     style={{
//                       width: "100%",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <div
//                       className="project-pagination-controls"
//                       style={{
//                         marginLeft: "auto",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "flex-end",
//                         gap: "6px",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {/* PREVIOUS */}
//                       <button
//                         onClick={() =>
//                           setHeadPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={headPage === 1}
//                       >   ‹ Previous  </button>

//                       {/* PAGE NUMBERS */}
//                       <div
//                         className="project-page-numbers"
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "4px",
//                         }}
//                       >
//                         {getPageNumbers(headPage, headTotalPages).map(
//                           (pageNumber, index) =>
//                             pageNumber === "..." ? (
//                               <span
//                                 key={`head-ellipsis-${index}`}
//                                 style={{
//                                   padding: "0 4px",
//                                 }}
//                               >
//                                 ...
//                               </span>
//                             ) : (
//                               <button
//                                 key={pageNumber}
//                                 className={
//                                   headPage === pageNumber ? "active" : ""
//                                 }
//                                 onClick={() => setHeadPage(pageNumber)}
//                               >
//                                 {pageNumber}
//                               </button>
//                             ),
//                         )}
//                       </div>

//                       {/* NEXT */}
//                       <button
//                         onClick={() =>
//                           setHeadPage((prev) =>
//                             Math.min(prev + 1, headTotalPages),
//                           )
//                         }
//                         disabled={
//                           headPage === headTotalPages || headTotalPages === 0
//                         }
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//       ) : (
//         <div className="project-table-page" style={{height:"90vh"}}>
//           <div
//             style={{
//               width: "100%",
//               display: "flex",
//               justifyContent: "flex-end",
//               marginBottom: "20px",
           
//             }}
//           >
//             {/* <button
//               onClick={() => setShowTable("")}
//               style={{
//                 padding: "8px 18px",
//                 border: "none",
//                 borderRadius: 8,
//                 cursor: "pointer",
//                 background: "#054ecf",
//                 color: "#fff",
//                 fontSize: "13px",
//                 fontWeight: "500",
//                 boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
//               }}
//             >
//               ← Back
//             </button> */}
//           </div>

//           {/* HEADER */}
//           {/* <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               marginBottom: 20,
//             }}
//           >
//             <button
//               onClick={() => setShowTable("")}
//               style={{
//                 border: "none",
//                 background: "transparent",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 src="/Back-Arrow-32.jpg"
//                 alt="Back"
//                 style={{
//                   width: 32,
//                 }}
//               />
//             </button>

//             <h4
//               style={{
//                 margin: 0,
//                 fontWeight: 700,
//               }}
//             >
//               {showTable === "project" }
//               {showTable === "head" && "Head Details"}

//               {showTable === "estimate" && "Estimate Amount Details"}

//               {showTable === "progress" && "Progress Report Details"}

//               {showTable === "workOrder" && "Work Order Details"}
//               {showTable === "limitAllocation" && "Limit Allocation Details"}

//               {showTable === "demand" && "Demand Generation Details"}

//               {showTable === "deduction" && "Deduction Amount Details"}
//               {showTable === "deductionDetails" && "deductionDetails Details"}
//             </h4>
//           </div> */}

// {/* 01-10 for search */}
//   <div
//   style={{
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: "20px",
//     marginBottom: "20px",
//     width: "100%",
//   }}
// >
//   {/* LEFT - Back Arrow + Heading */}
//   <div
//     style={{
//       display: "flex",
//       alignItems: "center",
//       gap: "18px",
//       flexShrink: 0,
//     }}
//   >
//             {/* <button
//               // onClick={() => setShowTable("")}
//               // 13-10
//               type="button"
//   onClick={handleBack}
//               style={{
//                 border: "none",
//                 background: "transparent",
//                 cursor: "pointer",
//               }}  >
//               <img
//                 src="/Back-Arrow-32.jpg"
//                 alt="Back"
//                 style={{
//                   width: 32,
//                 }}
//               />
//             </button> */}
//                {/* //24/10 search clear*/}
//             <button
//   onClick={() => {
//     clearAllSearchTerms();
//     setShowTable("");
//   }}
//   style={{ border: "none", background: "transparent", cursor: "pointer" }}  >
//   <img src="/Back-Arrow-32.jpg" alt="Back" style={{ width: 32 }} />
// </button>
 
//     <h4
//       style={{
//         margin: 0,
//         fontWeight: 700,
//         fontSize: "24px",
//         color: "#111",
//         whiteSpace: "nowrap",
//       }}
//     >
//       {showTable === "project" && "Project Cost Details"}
//       {showTable === "head" && "Head Details"}
//       {showTable === "estimate" && "Estimate Details"}
//       {showTable === "progress" && "Progress Report Details"}
//       {showTable === "workOrder" && "Work Order Details"}
//       {showTable === "limitAllocation" && "Limit Allocation Details"}
//       {showTable === "demand" && "Demand Generation Details"}
//       {showTable === "deduction" && "Deduction Details"}
//       {showTable === "deductionDetails" && "Deduction Details"}
//     </h4>
//   </div>
 
//   {/* RIGHT - Search Input */}
//   <div
//     className="search-container"
//     style={{
//       marginLeft: "auto",
//       flexShrink: 0,
//     }}
//   >
//     <img
//       src="/Search-32.png"
//       alt="Search Icon"
//       className="search-icon"
//     />
 
//     <input
//       type="text"
//       className="search-input"
//       placeholder={
//         showTable === "progress"
//           ? "Search Progress Report..."
//           : showTable === "project"
//           ? "Search Project..."
//             : showTable === "head"
//     ? "Search Head..."
//           : showTable === "estimate"
//           ? "Search Estimate..."
//           : showTable === "workOrder"
//           ? "Search Work Order..."
//           : showTable === "limitAllocation"
//           ? "Search Limit Allocation..."
//           : showTable === "demand"
//           ? "Search Demand..."
//           : showTable === "deduction"
//           ? "Search Deduction..."
//           : showTable === "deductionDetails"
//     ? "Search Deduction Details..."
//           : "Search..."
//       }
//       value={
//         showTable === "progress"
//           ? progressSearchTerm
//           : showTable === "project"
//           ? projectSearchTerm
//            : showTable === "head"
//     ? headSearchTerm
//           : showTable === "estimate"
//           ? estimateSearchTerm
//           : showTable === "workOrder"
//           ? workOrderSearchTerm
//           : showTable === "limitAllocation"
//           ? limitSearchTerm
//           : showTable === "demand"
//           ? demandSearchTerm
//           : showTable === "deduction"
//           ? deductionSearchTerm
//            : showTable === "deductionDetails"
//     ? deductionDetailsSearchTerm
//           : ""
//       }
//       onChange={(e) => {
//         const value = e.target.value;
 
//         if (showTable === "progress") setProgressSearchTerm(value);
//         if (showTable === "project") setProjectSearchTerm(value);
//          if (showTable === "head") setHeadSearchTerm(value);
//         if (showTable === "estimate") setEstimateSearchTerm(value);
//         if (showTable === "workOrder") setWorkOrderSearchTerm(value);
//         if (showTable === "limitAllocation") setLimitSearchTerm(value);
//         if (showTable === "demand") setDemandSearchTerm(value);
//         if (showTable === "deduction") setDeductionSearchTerm(value);
//          if (showTable === "deductionDetails") setDeductionDetailsSearchTerm(value); //22-10
//       }}
//     />
//   </div>
// </div>
 


// {/* 30-09 for search */}
//           {showTable === "project" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
              
//      {/* <div className="project-cost-header">
      
     
//       <h2 className="project-cost-title">
//         Project Cost Details
//       </h2>
 
//       <div className="search-container">
//         <img
//           src="/Search-32.png"
//           alt="Search Icon"
//           className="search-icon"
//         />
 
//         <input
//           type="text"
//           className="search-input"
//           placeholder="Search Project..."
//           value={projectSearchTerm}
//           onChange={(e) => setProjectSearchTerm(e.target.value)}
//         />
//       </div>
 
//     </div> */}
//               <table className="custom-table project-cost-table">
             
 
//                 <thead >
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Financial Year</th>
//                     <th style={{width:"130px"}}>Scheme</th>
//                     <th>Project Name</th>
//                     <th>Implementing Agency</th>
//                     <th style={{width:"150px"}}>Project Cost</th>
//                     <th>GR Number</th>
//                     <th style={{width:"150px"}}>GR Date</th>
//                     <th>Creation Date</th>
//                   </tr>
//                 </thead>
//                 <tbody >
//                   {currentProjectTableData.length ? (
//                     currentProjectTableData.map((project, index) => (
//                       <tr key={project.ID}>
//                         <td>{projectIndexOfFirst + index + 1}</td>
//                         <td>{project.FinancialYear || "-"}</td>
//                         <td style={{width:"130px"}}>{project.Scheme || "-"}</td>
//                         <td>{project.ProjectName || "-"}</td>
//                         <td>{project.Agency_Name || project.PIU || "-"}</td>
//                         <td style={{width:"150px"}}>₹ {fmt(project.ProjectCost)}</td>
//                         <td>{project.GRNumber || "-"}</td>
//                         <td style={{width:"150px"}}>
//                           {project.GRDate
//                             ? new Date(project.GRDate).toLocaleDateString(
//                                 "en-IN",
//                               )
//                             : "-"}
//                         </td>
//                         <td>
//                           {project.Date
//                             ? new Date(project.Date).toLocaleDateString("en-IN")
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* <td colSpan="9" style={{ textAlign: "center" }}>
//                         No Project Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>

//  {/* 22-10 for static msg */}
//                {currentProjectTableData.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Project Found
//     </div>
//   )}

// </div>
//  {filteredProjectTableData.length > 0 && (
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "15px",
//                   padding: "10px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 {/* <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing{" "}
//                   {projectTableData.length === 0 ? 0 : projectIndexOfFirst + 1}{" "}
//                   to {Math.min(projectIndexOfLast, projectTableData.length)} of{" "}
//                   {projectTableData.length} entries
//                 </div> */}

//                 {/* Pagination */}
//                 <div
//                   style={{
//                     width: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     marginTop: "15px",
//                     padding: "10px 5px",
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   {/* Showing Entries */}
//                   <div
//                     style={{
//                       fontSize: "13px",
//                       color: "#333",
//                       whiteSpace: "nowrap",
//                     }}
//                   >
//                      {/* //23/10 search functionality */}
//                      Showing{" "}
//   {filteredProjectTableData.length === 0 ? 0 : projectIndexOfFirst + 1} to{" "}
//   {Math.min(projectIndexOfLast, filteredProjectTableData.length)} of{" "}
//   {filteredProjectTableData.length} entries
//                   </div>

//                   {/* Pagination */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "20px",
//                     }}
//                   >
//                     {/* Previous */}
//                     <button
//                       onClick={() =>
//                         setProjectCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={projectCurrentPage === 1}
//                       style={{
//                         border: "none",
//                         background: "transparent",
//                         color: projectCurrentPage === 1 ? "#999" : "#2ea4e7",
//                         cursor:
//                           projectCurrentPage === 1 ? "not-allowed" : "pointer",
//                         fontSize: "13px",
//                         padding: 0,
//                       }}
//                     >
//                       <span style={{ fontSize: "18px" }}>‹</span>
//                       Previous
//                     </button>

//                     {/* Page Numbers */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "20px",
//                       }}
//                     >
//                       {getPageNumbers(
//                         projectCurrentPage,
//                         projectTotalPages,
//                       ).map((pageNumber, index) => (
//                         <button
//                           key={`${pageNumber}-${index}`}
//                           disabled={pageNumber === "..."}
//                           onClick={() => {
//                             if (pageNumber !== "...") {
//                               setProjectCurrentPage(pageNumber);
//                             }
//                           }}
//                           style={{
//                             border: "none",
//                             background: "transparent",
//                             padding: 0,
//                             color:
//                               projectCurrentPage === pageNumber
//                                 ? "#2ea4e7"
//                                 : "#444",
//                             cursor:
//                               pageNumber === "..." ? "default" : "pointer",
//                             fontSize: "13px",
//                             fontWeight:
//                               projectCurrentPage === pageNumber ? "600" : "400",
//                             textDecoration:
//                               projectCurrentPage === pageNumber
//                                 ? "underline"
//                                 : "none",
//                           }}
//                         >
//                           {pageNumber}
//                         </button>
//                       ))}
//                     </div>

//                     {/* Next */}
//                     <button
//                       onClick={() =>
//                         setProjectCurrentPage((prev) =>
//                           Math.min(prev + 1, projectTotalPages),
//                         )
//                       }
//                       disabled={projectCurrentPage === projectTotalPages}
//                       style={{
//                         border: "none",
//                         background: "transparent",
//                         color:
//                           projectCurrentPage === projectTotalPages
//                             ? "#999"
//                             : "#2ea4e7",
//                         cursor:
//                           projectCurrentPage === projectTotalPages
//                             ? "not-allowed"
//                             : "pointer",
//                         fontSize: "13px",
//                         padding: 0,
//                       }}
//                     >
//                       Next
//                       <span style={{ fontSize: "18px" }}>›</span>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//  )}
//             </div>
//           )}

//           {showTable === "head" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}> Sr No</th>
//                     <th>Financial Year</th>
//                     <th>Head ID</th>
//                     <th>Head Name</th>
//                     <th>Project Name</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                     {/* {headDetailsTableData.length ? (
//                     headDetailsTableData.map((project, index) => ( */}
//                   {currentHeadDetails.length ? (
//                     currentHeadDetails.map((project, index) => (
//                       <tr key={project.ID}>
//                         <td>{headDetailsIndexOfFirst +index + 1}</td>
//                         <td>{project.FinancialYear || "-"}</td>
//                         <td>{project.HeadID || "-"}</td>
//                         <td>{project.HeadName || "-"}</td>
//                         <td>{project.ProjectName || "-"}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* <td colSpan="9" style={{ textAlign: "center" }}>
//                         No Project Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//                 {/* 22-10 for satic msg  */}
//                 {currentHeadDetails.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No head projects Found
//     </div>
//   )}
//               </div>
//                {currentHeadDetails.length > 0 && (
//               <div className="project-pagination">
//                 {/* LEFT - SHOWING ENTRIES */}
//                 {/* <div className="project-pagination-info">
//                   Showing{" "}
//                   {headDetailsTableData.length === 0
//                     ? 0
//                     : headDetailsIndexOfFirst + 1}{" "}
//                   to{" "}
//                   {Math.min(
//                     headDetailsIndexOfLast,
//                     headDetailsTableData.length,
//                   )}{" "}
//                   of {headDetailsTableData.length} entries
//                 </div> */}
//                 {/* 12-09 */}
//                 <div className="project-pagination-info">
//   {/* Showing{" "}
//   {headDetailsTableSource.length === 0
//     ? 0
//     : headDetailsIndexOfFirst + 1}{" "}
//   to{" "}
//   {Math.min(
//     headDetailsIndexOfLast,
//     headDetailsTableSource.length,
//   )}{" "}
//   of {headDetailsTableSource.length} entries */}
//   {/* 01-10  */}
//   Showing{" "}
//   {filteredHeadDetailsTableData.length === 0
//     ? 0
//     : headDetailsIndexOfFirst + 1}
//   {" "}to{" "}
//   {Math.min(
//     headDetailsIndexOfLast,
//     filteredHeadDetailsTableData.length
//   )}
//   {" "}of{" "}
//   {filteredHeadDetailsTableData.length} entries
// </div>

//                 {/* RIGHT - PAGINATION */}
//                 <div className="project-pagination-controls">
//                   {/* PREVIOUS */}
//                   <button
//                     onClick={() =>
//                       setHeadDetailsCurrentPage((prev) => Math.max(prev - 1, 1))
//                     }
//                     disabled={headDetailsCurrentPage === 1}
//                   >
//                     ‹ Previous
//                   </button>

//                   {/* PAGE NUMBERS */}
//                   <div className="project-page-numbers">
//                     {Array.from(
//                       { length: headDetailsTotalPages },
//                       (_, index) => index + 1,
//                     ).map((pageNumber) => (
//                       <button
//                         key={pageNumber}
//                         className={
//                           headDetailsCurrentPage === pageNumber ? "active" : ""
//                         }
//                         onClick={() => setHeadDetailsCurrentPage(pageNumber)}
//                       >
//                         {pageNumber}
//                       </button>
//                     ))}
//                   </div>

//                   {/* NEXT */}
//                   <button
//                     onClick={() =>
//                       setHeadDetailsCurrentPage((prev) =>
//                         Math.min(prev + 1, headDetailsTotalPages),
//                       )
//                     }
//                     disabled={headDetailsCurrentPage === headDetailsTotalPages}
//                   >
//                     Next ›
//                   </button>
//                 </div>
//               </div>
//                )}
//             </div>
//           )}

//           {showTable === "progress" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll" style={{ width: "100%" }}>
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}> Sr No</th>
//                     <th>Project ID</th>
//                     <th>Project Name</th>
//                     <th>Physical Progress</th>
                   
//                     <th>Remark</th>
//                     <th>Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentProgressTableData.length > 0 ? (
//                     currentProgressTableData.map((item, index) => (
//                       <tr key={item.UploadID || index}>
//                         <td>{progressIndexOfFirst + index + 1}</td>

//                         <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.ProjectID || "-"}</td>

//                         <td>{item.ProjectName || "-"}</td>

//                         <td>
//                           {/* {item.PhysicalProgress || "-"}  */}

//                            {/* <button
//                                 className="btn btn-success px-3"
//                                 onClick={() => {console.log("Clicked row UploadID:-----", item.ID, item);
//                                   fetchSpecficUploadPhoto(
//                                     item.ID,
//                                     // item.ID, 
//                                     item.WorkOrderNo,
//                                     item.PhysicalProgress,
//                                   )
//                                 }}
//                                 style={{
//                                   fontSize: "12px",
//                                   background:
//                                     "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                   color: "white",
//                                   border: "none",
//                                   padding: "6px 12px",
//                                   borderRadius: "8px",
//                                   display: "inline-flex",
//                                   justifyContent: "center",
//                                   alignItems: "center",
//                                   gap: "4px",
//                                   whiteSpace: "nowrap",
//                                 }}
//                               >
//                                 {("View Photos")}
//                               </button> */}
//                               <button
//   className="btn btn-success px-3"
//   onClick={() => {
//     console.log("Clicked Progress ID:",  item.UploadID,);

//     fetchSpecficUploadPhoto(
//        item.UploadID, // Progress ID = 83, use as UploadID
//       item.WorkOrderNo,
//       item.PhysicalProgress
//     );
//   }}
//   style={{
//     fontSize: "12px",
//     background:
//       "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//     color: "white",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "8px",
//     display: "inline-flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "4px",
//     whiteSpace: "nowrap",
//     marginLeft:"10px"
//   }}
// >
//   View Photos
// </button>
//                         </td>
                        

//                         <td>{item.Description || "-"}</td>

//                         <td>
//                           {item.Date
//                             ? new Date(item.Date).toLocaleDateString("en-IN")
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* <td colSpan="6" style={{ textAlign: "center" }}>
//                         No Progress Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//                    {/* 22-10 for static msg */}
//                 {currentProgressTableData.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Project Found
//     </div>
//   )}
//               </div>

//               {/* ================= PROGRESS PAGINATION ================= */}
// {currentProgressTableData.length > 0 && (
//                 <div className="project-pagination">
//                   {/* INFO */}
//                   <div className="project-pagination-info">
//                     {/* Showing {progressIndexOfFirst + 1} to{" "}
//                     {Math.min(progressIndexOfLast, progressTableData.length)} of{" "}
//                     {progressTableData.length} entries */}
//                     {/* 01-10 */}
//                      Showing{" "}
//       {filteredProgressTableData.length === 0 ? 0 : progressIndexOfFirst + 1}{" "}
//       to{" "}
//       {Math.min(progressIndexOfLast, filteredProgressTableData.length)} of{" "}
//       {filteredProgressTableData.length} entries
//                   </div>

//                   {/* CONTROLS */}
//                   <div className="project-pagination-controls">
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProgressCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={progressCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         progressCurrentPage,
//                         progressTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`progress-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`progress-page-${pageNumber}`}
//                             className={
//                               progressCurrentPage === pageNumber ? "active" : ""
//                             }
//                             onClick={() => setProgressCurrentPage(pageNumber)}
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProgressCurrentPage((prev) =>
//                           Math.min(prev + 1, progressTotalPages),
//                         )
//                       }
//                       disabled={progressCurrentPage >= progressTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
// )}
//             </div>
//           )}

//              {showTable === "estimate" && (
//   <div className="dashboard-table-card project-cost-card">
//     <div className="project-cost-scroll">
//       <table className="custom-table project-cost-table">
//         <thead>
//           <tr>
//             <th style={{ width: "60px" }}>Sr. No</th>
//             <th>Project ID</th>
//             <th>Project Name</th>
//             <th>Financial Year</th>
//             <th>Budget Head</th>
//             <th>Object Code</th>
//             <th>Estimate Amount</th>
//             <th>Creation Date</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentEstimates.length ? (
//             currentEstimates.map((item, index) => (
//               <tr key={item.ID || index}>
//                 <td>{estimateIndexOfFirst + index + 1}</td>
//                 <td style={{ color: "rgb(82, 149, 201)", textAlign: "center" }}>
//                   {item.ProjectID}
//                 </td>
//                 <td>{item.ProjectName}</td>
//                 <td>{item.Year}</td>
//                 <td>{item.BudgetHead}</td>
//                 <td>{item.ObjectCode}</td>
//                 <td>₹ {fmt(item.EsitmateAmount)}</td>
//                 <td>
//                   {item.Date
//                     ? new Date(item.Date).toLocaleDateString("en-IN")
//                     : "-"}
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               {/* <td colSpan="8" style={{ textAlign: "center" }}>
//                 No Estimate Found
//               </td> */}
//             </tr>
//           )}
//         </tbody>
//       </table>
//         {currentEstimates.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Estimate Found
//     </div>
//   )}
//     </div>

//     {/* ================= ESTIMATE PAGINATION ================= */}
//     {filteredEstimateTableData.length > 0 && (
//       <div className="project-pagination">
//         <div className="project-pagination-info">
//           Showing {estimateIndexOfFirst + 1} to{" "}
//           {Math.min(estimateIndexOfLast, filteredEstimateTableData.length)} of{" "}
//           {filteredEstimateTableData.length} entries
//         </div>

//         <div className="project-pagination-controls">
//           <button
//             type="button"
//             onClick={() =>
//               setEstimateCurrentPage((prev) => Math.max(prev - 1, 1))
//             }
//             disabled={estimateCurrentPage === 1}
//           >
//             ‹ Previous
//           </button>

//           <div className="project-page-numbers">
//             {getPageNumbers(estimateCurrentPage, estimateTotalPages).map(
//               (pageNumber, index) =>
//                 pageNumber === "..." ? (
//                   <span key={`estimate-ellipsis-${index}`}>...</span>
//                 ) : (
//                   <button
//                     type="button"
//                     key={`estimate-page-${pageNumber}`}
//                     className={
//                       estimateCurrentPage === pageNumber ? "active" : ""
//                     }
//                     onClick={() => setEstimateCurrentPage(pageNumber)}
//                   >
//                     {pageNumber}
//                   </button>
//                 ),
//             )}
//           </div>

//           <button
//             type="button"
//             onClick={() =>
//               setEstimateCurrentPage((prev) =>
//                 Math.min(prev + 1, estimateTotalPages),
//               )
//             }
//             disabled={estimateCurrentPage >= estimateTotalPages}
//           >
//             Next ›
//           </button>
//         </div>
//       </div>
//     )}
//   </div>
// )}

//           {showTable === "limitAllocation" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Limit ID</th>
//                     <th>Financial Year</th>
//                     <th>Project Name</th>
//                     <th>Limit Amount</th>
//                     <th>Limit Date</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* {limitAllocationTableData.length ? (
//                     limitAllocationTableData.map((item, index) => (
//                       <tr key={item.ID || index}> */}
//                       {/* 01-10 */}
//                       {currentLimitAllocations.length ? (
//   currentLimitAllocations.map((item, index) => (
// <tr key={item.ID || index}>
// <td>{limitAllocationIndexOfFirst + index + 1}</td>
//                         {/* <td>{index + 1}</td> */}
//                         <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.ReleaseID}</td>
//                         <td>{item.FinancialYear}</td>
//                         <td>{item.ProjectName}</td>
//                         <td>₹ {fmt(item.ReleaseAmountTillDate)}</td>
//                         <td>
//                           {item.ReleaseDate
//                             ? new Date(item.ReleaseDate).toLocaleDateString(
//                                 "en-IN",
//                               )
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* <td colSpan="6" style={{ textAlign: "center" }}>
//                         No Fund Allocation Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>

//                 {/* 24-10 add total of limit allocation */}
//                 {currentLimitAllocations.length > 0 && (
//                   <tr>
//                     <td colSpan={4} style={{ fontWeight: "bold" }}>
//                       Total
//                     </td>

//                     <td style={{ fontWeight: "bold" }}>
//                       ₹{" "}
//                       {filteredLimitAllocationTableData
//                         .reduce(
//                           (sum, item) =>
//                             sum +
//                             Number(
//                               item.ReleaseAmountTillDate ??
//                               item.ReleaseAmount ??
//                               item.LimitAmount ??
//                               0
//                             ),
//                           0
//                         )
//                         .toLocaleString("en-IN")}
//                     </td>

//                     <td></td>
//                   </tr>
//                 )}

//               </table>
//                    {currentLimitAllocations.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Limit Allocation Found 
//     </div>
//   )}
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "15px",
//                   padding: "10px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 {/* LIMIT ALLOCATION PAGINATION */}
//                 {limitAllocationTableData.length > 0 && (
//                   <div className="project-pagination">
//                     {/* SHOWING ENTRIES */}
//                     <div className="project-pagination-info">
//                       {/* Showing {limitAllocationIndexOfFirst + 1} to{" "}
//                       {Math.min(
//                         limitAllocationIndexOfLast,
//                         limitAllocationTableData.length,
//                       )}{" "}
//                       of {limitAllocationTableData.length} entries */}
//                       {/* 01-10 */}
//                         Showing {limitAllocationIndexOfFirst + 1} to{" "}
//           {Math.min(
//             limitAllocationIndexOfLast,
//             filteredLimitAllocationTableData.length,
//           )}{" "}
//           of {filteredLimitAllocationTableData.length} entries
 
//                     </div>

//                     {/* PAGINATION CONTROLS */}
//                     <div className="project-pagination-controls">
//                       {/* PREVIOUS */}
//                       <button
//                         onClick={() =>
//                           setLimitAllocationCurrentPage((prev) =>
//                             Math.max(prev - 1, 1),
//                           )
//                         }
//                         disabled={limitAllocationCurrentPage === 1}
//                       >
//                         ‹ Previous
//                       </button>

//                       {/* PAGE NUMBERS */}
//                       <div className="project-page-numbers">
//                         {getPageNumbers(
//                           limitAllocationCurrentPage,
//                           limitAllocationTotalPages,
//                         ).map((pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span key={`limit-ellipsis-${index}`}>...</span>
//                           ) : (
//                             <button
//                               key={pageNumber}
//                               className={
//                                 limitAllocationCurrentPage === pageNumber
//                                   ? "active"
//                                   : ""
//                               }
//                               onClick={() =>
//                                 setLimitAllocationCurrentPage(pageNumber)
//                               }
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                         )}
//                       </div>

//                       {/* NEXT */}
//                       <button
//                         onClick={() =>
//                           setLimitAllocationCurrentPage((prev) =>
//                             Math.min(prev + 1, limitAllocationTotalPages),
//                           )
//                         }
//                         disabled={
//                           limitAllocationCurrentPage ===
//                           limitAllocationTotalPages
//                         }
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {showTable === "workOrder" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div style={{ width: "100%" }}>
//               {/* ================= WORK ORDER TABLE ================= */}
//               <div className="project-cost-scroll">
//                 <table className="custom-table project-cost-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Financial Year</th>
//                       <th>Project Name</th>
//                       <th>Project Cost</th>
//                       <th>Agency Name</th>
//                       <th>Work Name</th>
//                       <th>Work Order Number</th>
//                       <th style={{width:"100px"}}>Date</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentWorkOrders.length > 0 ? (
//                       currentWorkOrders.map((item, index) => (
//                         <tr key={item.ID || index}>
//                           <td>{workOrderIndexOfFirst + index + 1}</td>

//                           <td>{item.FinancialYear}</td>

//                           <td>{item.ProjectName}</td>

//                           <td>
//                             {Number(item.ProjectCost || 0).toLocaleString(
//                               "en-IN",
//                             )}
//                           </td>

//                           <td>{item.CreatedByAgency}</td>

//                           <td>{item.WorkName}</td>

//                           <td>{item.WorkOrderNo}</td>

//                           <td style={{width:"100px"}}>
//                             {item.WorkOrderDate
//                               ? new Date(item.WorkOrderDate).toLocaleDateString(
//                                   "en-IN",
//                                 )
//                               : "-"}
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         {/* <td colSpan="8" style={{ textAlign: "center" }}>
//                           No Work Orders Found
//                         </td> */}
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//                          {currentWorkOrders.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Work order Found
//     </div>
//   )}
//                 </div>
//               </div>

//               {/* ================= SHOWING + PAGINATION ================= */}
//               {workOrderTableData.length > 0 && (
//                 <div
//                   style={{
//                     width: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     marginTop: "15px",
//                     padding: "10px 5px",
//                     boxSizing: "border-box",
//                     overflow: "visible",
//                   }}
//                 >
//                   {/* ================= SHOWING ENTRIES ================= */}
//                   <div
//                     style={{
//                       fontSize: "13px",
//                       color: "#333",
//                       whiteSpace: "nowrap",
//                       flexShrink: 0,
//                     }}
//                   >
//                     Showing {workOrderIndexOfFirst + 1} to{" "}
//                     {Math.min(workOrderIndexOfLast, workOrderTableData.length)}{" "}
//                     of {workOrderTableData.length} entries
//                   </div>

//                   {/* ================= PAGINATION ================= */}
//                   <div
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "4px",
//                       flexShrink: 0,
//                     }}
//                   >
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setWorkOrderCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={workOrderCurrentPage === 1}
//                       style={{
//                         border: "none",
//                         background: "transparent",
//                         padding: "6px 8px",
//                         fontSize: "13px",
//                         color: workOrderCurrentPage === 1 ? "#aaa" : "#777",
//                         cursor:
//                           workOrderCurrentPage === 1 ? "default" : "pointer",
//                       }}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     {getPageNumbers(
//                       workOrderCurrentPage,
//                       workOrderTotalPages,
//                     ).map((pageNumber, index) => {
//                       if (pageNumber === "...") {
//                         return (
//                           <span
//                             key={`work-order-dots-${index}`}
//                             style={{
//                               padding: "6px 5px",
//                               fontSize: "13px",
//                               color: "#777",
//                             }}
//                           >
//                             ...
//                           </span>
//                         );
//                       }

//                       return (
//                         <button
//                           type="button"
//                           key={`work-order-page-${pageNumber}`}
//                           onClick={() => setWorkOrderCurrentPage(pageNumber)}
//                           style={{
//                             border: "none",
//                             background: "transparent",
//                             padding: "6px 5px",
//                             fontSize: "13px",
//                             color:
//                               workOrderCurrentPage === pageNumber
//                                 ? "#007bff"
//                                 : "#555",
//                             cursor: "pointer",
//                             fontWeight:
//                               workOrderCurrentPage === pageNumber
//                                 ? "500"
//                                 : "400",
//                           }}
//                         >
//                           {pageNumber}
//                         </button>
//                       );
//                     })}

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setWorkOrderCurrentPage((prev) =>
//                           Math.min(prev + 1, workOrderTotalPages),
//                         )
//                       }
//                       disabled={workOrderCurrentPage >= workOrderTotalPages}
//                       style={{
//                         border: "none",
//                         background: "transparent",
//                         padding: "6px 8px",
//                         fontSize: "13px",
//                         color:
//                           workOrderCurrentPage >= workOrderTotalPages
//                             ? "#aaa"
//                             : "#777",
//                         cursor:
//                           workOrderCurrentPage >= workOrderTotalPages
//                             ? "default"
//                             : "pointer",
//                       }}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//           {showTable === "demand" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Bill UID</th>
//                     <th>RA Bill Number</th>
//                     <th>Contractor Name</th>
//                     <th>Work Name</th>
//                     <th>Bill Amount</th>
//                     <th>Deduction Amount</th>
//                     <th>Payable Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* {demandTableData.length ? (
//                     demandTableData.map((item, index) => (
//                       <tr key={item.ID || index}> */}
//                       {/* 01-10 */}
//                       {currentDemands.length ? (
//   currentDemands.map((item, index) => (
// <tr key={item.ID || index}>
// <td>{demandIndexOfFirst + index + 1}</td>
//                         {/* <td>{index + 1}</td> */}
//                         <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.DemandGenerationID}</td>
//                         <td>{item.RABillNumber}</td>
//                         <td>{item.ContractorName}</td>
//                         <td>{item.WorkName}</td>
//                         <td>{item.BillAmount}</td>
//                         <td>₹ {fmt(item.DeductionAmount)}</td>
//                         <td>₹ {fmt(item.NetPayableAmount)}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* 01/10 add padding */}
//                       {/* <td colSpan="5" style={{ textAlign: "center", paddingLeft:"450px" }}> 
//                         No Demand Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//                            {currentDemands.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Project Found
//     </div>
//   )}
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "15px",
//                   padding: "10px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 {demandTableData.length > 0 && (
//                   <div className="project-pagination">
//                     {/* SHOWING ENTRIES */}
//                     <div className="project-pagination-info">
//                       {/* Showing {demandIndexOfFirst + 1} to{" "}
//                       {Math.min(demandIndexOfLast, demandTableData.length)} of{" "}
//                       {demandTableData.length} entries */}
//                       Showing {demandIndexOfFirst + 1} to{" "}
//                       {Math.min(demandIndexOfLast, demandTableData.length)} of{" "}
//                       {demandTableData.length} entries
//                     </div>

//                     {/* PAGINATION CONTROLS */}
//                     <div className="project-pagination-controls">
//                       {/* PREVIOUS */}
//                       <button
//                         onClick={() =>
//                           setDemandCurrentPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={demandCurrentPage === 1}
//                       >
//                         ‹ Previous
//                       </button>

//                       {/* PAGE NUMBERS */}
//                       <div className="project-page-numbers">
//                         {getPageNumbers(
//                           demandCurrentPage,
//                           demandTotalPages,
//                         ).map((pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span key={`demand-ellipsis-${index}`}>...</span>
//                           ) : (
//                             <button
//                               key={pageNumber}
//                               className={
//                                 demandCurrentPage === pageNumber ? "active" : ""
//                               }
//                               onClick={() => setDemandCurrentPage(pageNumber)}
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                         )}
//                       </div>

//                       {/* NEXT */}
//                       <button
//                         onClick={() =>
//                           setDemandCurrentPage((prev) =>
//                             Math.min(prev + 1, demandTotalPages),
//                           )
//                         }
//                         disabled={demandCurrentPage === demandTotalPages}
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {showTable === "deduction" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "80px", textAlign: "center" }}>
//                       Sr No
//                     </th>
//                     <th style={{ width: "160px", textAlign: "center" }}>
//                       Work Order Number
//                     </th>
//                     <th style={{ width: "200px", textAlign: "center" }}>
//                       Project Name
//                     </th>
//                     <th>Work Name</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* {deductionTableData.length ? (
//                     deductionTableData.map((item, index) => (
//                       <tr key={item.ID || index}>
//                         <td>{index + 1}</td> */}
//                         {/* 01-10 */}
//                         {currentDeductions.length ? (
//   currentDeductions.map((item, index) => (
// <tr key={item.ID || index}>
// <td>{deductionIndexOfFirst + index + 1}</td>
//                         <td>
//                           <span
//                             style={{
//                               color: "#0d6efd",
//                               cursor: "pointer",
//                               textDecoration: "underline",
//                             }}
//                             onClick={() =>
//                               getDeductionDetails(item.WorkOrderUID)
//                             }
//                           >
//                             {item.WorkOrderUID}
//                           </span>
//                         </td>
//                         <td>{item.ProjectName}</td>
//                         <td>{item.WorkName}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       {/* <td colSpan="5" style={{ textAlign: "center" }}>
//                         No Deduction Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//                       {currentDeductions.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//       No Project Found
//     </div>
//   )}
//               </div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "15px",
//                   padding: "10px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}

//                 {/* ================= DEDUCTION PAGINATION ================= */}

//                 {deductionTableData.length > 0 && (
//                   <div className="project-pagination">
//                     {/* SHOWING ENTRIES */}
//                     <div className="project-pagination-info">
//                       {/* Showing {deductionIndexOfFirst + 1} to{" "}
//                       {Math.min(
//                         deductionIndexOfLast,
//                         deductionTableData.length,
//                       )}{" "}
//                       of {deductionTableData.length} entries */}
//                       {/* 01-10 */}
//                          Showing {deductionIndexOfFirst + 1} to{" "}
//                      {Math.min(deductionIndexOfLast, filteredDeductionTableData.length)} of{" "}
// {filteredDeductionTableData.length} entries
//                     </div>

//                     {/* PAGINATION CONTROLS */}
//                     <div className="project-pagination-controls">
//                       {/* PREVIOUS */}
//                       <button
//                         onClick={() =>
//                           setDeductionCurrentPage((prev) =>
//                             Math.max(prev - 1, 1),
//                           )
//                         }
//                         disabled={deductionCurrentPage === 1}
//                       >
//                         ‹ Previous
//                       </button>

//                       {/* PAGE NUMBERS */}
//                       <div className="project-page-numbers">
//                         {getPageNumbers(
//                           deductionCurrentPage,
//                           deductionTotalPages,
//                         ).map((pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span key={`deduction-ellipsis-${index}`}>...</span>
//                           ) : (
//                             <button
//                               key={pageNumber}
//                               className={
//                                 deductionCurrentPage === pageNumber
//                                   ? "active"
//                                   : ""
//                               }
//                               onClick={() =>
//                                 setDeductionCurrentPage(pageNumber)
//                               }
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                         )}
//                       </div>

//                       {/* NEXT */}
//                       <button
//                         onClick={() =>
//                           setDeductionCurrentPage((prev) =>
//                             Math.min(prev + 1, deductionTotalPages),
//                           )
//                         }
//                         disabled={deductionCurrentPage === deductionTotalPages}
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           {showTable === "deductionDetails" && (
//               <div className="dashboard-table-card project-cost-card">
//             <div className="project-cost-scroll">
//               <h5 style={{ marginBottom: 15 }}>
//                 Work Order: {selectedWorkOrder}
//               </h5>
//               <table className="custom-table project-cost-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Deduction Name</th>
//                     <th>Deduction Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {deductionDetails.length ? (
//                     <>
//                       {deductionDetails.map((item, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                           <td>{item.DeductionName}</td>
//                           <td>₹ {fmt(item.DeductionAmount)}</td>
//                         </tr>
//                       ))}
//                       <tr style={{ fontWeight: "bold" }}>
//                         <td colSpan={2}>TOTAL</td>
//                         <td>
//                           ₹{" "}
//                           {fmt(
//                             deductionDetails.reduce(
//                               (sum, item) =>
//                                 sum + Number(item.DeductionAmount || 0),
//                               0,
//                             ),
//                           )}
//                         </td>
//                       </tr>
//                     </>
//                   ) : (
//                     <tr>
//                       {/* <td colSpan={3} style={{ textAlign: "center" }}>
//                         No Deduction Details Found
//                       </td> */}
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//                    {filteredDeductionDetails.length === 0 && (
//     <div
//       style={{
//         position: "sticky",
//         left: 0,
//         width: "100%",
//         minWidth: "100%",
//         height: "100px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#ffffff",
//         color: "#555",
//         fontSize: "14px",
//         boxSizing: "border-box",
//       }}
//     >
//         No Deduction Details Found
//     </div>
//   )}</div>
//               <div
//                 style={{
//                   width: "100%",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   marginTop: "15px",
//                   padding: "10px 5px",
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* Showing Entries */}
//                 {/* <div
//                   style={{
//                     fontSize: "13px",
//                     color: "#333",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   Showing{" "}
//                   {projectTableData.length === 0 ? 0 : projectIndexOfFirst + 1}{" "}
//                   to {Math.min(projectIndexOfLast, projectTableData.length)} of{" "}
//                   {projectTableData.length} entries
//                 </div> */}
//               </div>
//             </div>
//           )}
//         </div>
//       )}

//       {selectedImage && (
//   <div
//     style={{
//       position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
//       backgroundColor: "rgba(0, 0, 0, 0.85)", display: "flex",
//       justifyContent: "center", alignItems: "center", zIndex: 99999, padding: "20px",
//     }}
//     onClick={() => setSelectedImage(null)}
//   >
//     <button
//       type="button"
//       onClick={(e) => { e.stopPropagation(); setSelectedImage(null); }}
//       style={{
//         position: "absolute", top: "20px", right: "25px", width: "40px", height: "40px",
//         borderRadius: "50%", border: "none", backgroundColor: "rgba(255,255,255,0.9)",
//         color: "#000", fontSize: "25px", fontWeight: "bold", cursor: "pointer", zIndex: 100000,
//       }}
//     >
//       ×
//     </button>
//     <img
//       src={selectedImage}
//       alt="Uploaded Progress Report"
//       draggable={false}
//       onClick={(e) => e.stopPropagation()}
//       style={{
//         display: "block", width: "auto", height: "auto", maxWidth: "95vw", maxHeight: "95vh",
//         objectFit: "contain", borderRadius: "6px", boxShadow: "0 0 20px rgba(255,255,255,0.25)",
//       }}
//     />
//   </div>
// )}
//     </>
//   );
// }

// export default Dashboard;



import React, { useContext, useEffect, useMemo, useState } from "react";
import AdminContext from "../../admin/StateContext/Application";
import ReactApexChart from "react-apexcharts";
import Select from "react-select";
import "./dashboard.css";
import { apiurl } from "../../../path";

import {
  FaMapMarkerAlt,
  FaRegCalendarAlt,
  FaRegClock,
  FaMountain,
  FaBullseye,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaArrowCircleRight,
  FaUndoAlt,
} from "react-icons/fa";
import { TbLocation } from "react-icons/tb";

import {
  Approved32,
  Disable32,
} from "../../../public/LoginImages/importimages";

/* =====================================================================
   PURE HELPERS (no component state)
   ===================================================================== */
const PER_PAGE = 10;
const BILLS_PER_PAGE = 2;
const HEADS_PER_PAGE = 8;

const fmt = (n) => Number(n || 0).toLocaleString("en-IN");
const rupee = (n) => `₹ ${fmt(n)}`;
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN") : "-");

const sortLatestFirst = (list) => {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    const dateA = new Date(a.Date || a.CreatedAt || a.CreationDate || 0).getTime();
    const dateB = new Date(b.Date || b.CreatedAt || b.CreationDate || 0).getTime();
    return dateB - dateA;
  });
};

// true when ANY of the given keys contains the search text
const matches = (item, term, keys) => {
  const s = term.trim().toLowerCase();
  if (!s) return true;
  return keys.some((k) => String(item[k] ?? "").toLowerCase().includes(s));
};

const paginate = (list, page, perPage) => {
  const last = page * perPage;
  const first = last - perPage;
  return {
    totalPages: Math.ceil(list.length / perPage),
    first,
    last,
    items: list.slice(first, last),
  };
};

const getPageNumbers = (currentPage, totalPages) => {
  const maxVisiblePages = 10;
  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (currentPage <= 3) return [1, 2, 3, 4, 5, "...", totalPages];
  if (currentPage >= totalPages - 2) {
    return ["...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  return [
    "...",
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
    "...",
    totalPages,
  ];
};

// page state that jumps back to 1 whenever the reset keys change
const usePage = (resetKeys) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetKeys);
  return [page, setPage];
};

const parseLocations = (location) => {
  try {
    if (Array.isArray(location)) {
      return location.map((loc) => (typeof loc === "string" ? JSON.parse(loc) : loc));
    }
    const parsed = JSON.parse(location || "[]");
    return parsed.map((loc) => (typeof loc === "string" ? JSON.parse(loc) : loc));
  } catch {
    return [];
  }
};

/* =====================================================================
   STATIC CONFIG
   ===================================================================== */
const TABLE_TITLES = {
  project: "Project Cost Details",
  head: "Head Details",
  estimate: "Estimate Details",
  progress: "Progress Report Details",
  workOrder: "Work Order Details",
  limitAllocation: "Limit Allocation Details",
  demand: "Demand Generation Details",
  deduction: "Deduction Details",
  deductionDetails: "Deduction Details",
};

const PHOTO_THEME = { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" };

const SPEND_SERIES = [
  { name: "High - 2013", data: [28, 29, 33, 36, 32, 32, 33] },
  { name: "Low - 2013", data: [12, 11, 14, 18, 17, 13, 13] },
];

const SPEND_OPTIONS = {
  chart: {
    type: "area",
    width: "100%",
    parentHeightOffset: 0,
    zoom: { enabled: false },
    toolbar: { show: false },
  },
  colors: ["#1e9e6a", "#f0583f"],
  stroke: { width: [4, 4], curve: "smooth" },
  fill: {
    type: "gradient",
    gradient: { shade: "light", type: "vertical", opacityFrom: 0.45, opacityTo: 0, stops: [0, 100] },
  },
  dataLabels: { enabled: false },
  grid: { borderColor: "#c9d3e3", strokeDashArray: 3 },
  markers: { size: 0, hover: { size: 6 } },
  tooltip: { enabled: true, theme: "dark" },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    labels: { style: { colors: "#6b7280", fontSize: "12px" } },
  },
  yaxis: { labels: { style: { colors: "#6b7280", fontSize: "12px" } } },
  legend: { show: true, position: "top", horizontalAlign: "center", fontSize: "11px" },
};

const DONUT_BASE_OPTIONS = {
  chart: { type: "donut", width: 320 },
  labels: ["Project Cost", "Esitmate Amount", "Release Amount", "Demand Generated"],
  colors: ["#38d1bd", "#50bdf5", "#ee574c", "#7f47dd"],
  legend: {
    position: "bottom",
    horizontalAlign: "center",
    fontSize: "13px",
    markers: { radius: 12, width: 12, height: 12 },
  },
  dataLabels: { enabled: false },
  tooltip: {
    custom: function ({ series, seriesIndex, w }) {
      const label = w.globals.labels[seriesIndex];
      const raw = w.config.rawValues ? w.config.rawValues[seriesIndex] : series[seriesIndex];
      return (
        '<div style="padding:8px 12px;font-size:13px;">' +
        "<strong>" + label + "</strong><br/>" +
        "₹ " + Number(raw || 0).toLocaleString("en-IN") +
        "</div>"
      );
    },
  },
  rawValues: [0, 0, 0, 0],
  responsive: [
    { breakpoint: 480, options: { chart: { width: 240 }, legend: { position: "bottom" } } },
  ],
};

const DEDUCTION_PIE_BASE = {
  chart: { width: 380, type: "pie" },
  labels: [],
  legend: { position: "bottom", horizontalAlign: "center", fontSize: "14px", markers: { radius: 12 } },
  responsive: [
    { breakpoint: 480, options: { chart: { width: 200 }, legend: { position: "bottom" } } },
  ],
};

/* react-select */
const DASH_SELECT_PROPS = {
  isSearchable: true,
  isClearable: true,
  menuPosition: "fixed",
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
};

const dashSelectStyles = (width) => ({
  container: (b) => ({ ...b, width }),
  control: (b, s) => ({
    ...b,
    width,
    minHeight: "40px",
    height: "40px",
    borderRadius: "6px",
    border: "1px solid #cfd4dc",
    boxShadow: s.isFocused ? "0 0 0 1px #2684ff" : "none",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "13px",
  }),
  valueContainer: (b) => ({ ...b, padding: "2px 10px" }),
  input: (b) => ({ ...b, fontSize: "13px" }),
  placeholder: (b) => ({ ...b, color: "#777", fontSize: "13px", whiteSpace: "nowrap" }),
  singleValue: (b) => ({
    ...b,
    color: "#222",
    fontSize: "13px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (b) => ({ ...b, color: "#999", padding: "6px 8px" }),
  clearIndicator: (b) => ({ ...b, padding: "6px" }),
  menu: (b) => ({
    ...b,
    width,
    marginTop: "4px",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    zIndex: 99999,
  }),
  menuList: (b) => ({ ...b, maxHeight: "220px", overflowY: "auto", padding: "4px 0" }),
  menuPortal: (b) => ({ ...b, zIndex: 99999 }),
  option: (b, s) => ({
    ...b,
    fontSize: "13px",
    padding: "10px 12px",
    backgroundColor: s.isSelected ? "#0d6efd" : s.isFocused ? "#eaf3ff" : "#fff",
    color: s.isSelected ? "#fff" : "#222",
    cursor: "pointer",
  }),
});

/* =====================================================================
   SMALL PRESENTATION COMPONENTS
   ===================================================================== */

// theme = blue | purple | orange | green | pink | indigo | teal | red
const DashStatCard = ({ theme, icon, title, value, onClick, tall = false }) => (
  <div className={`dash-card dash-card--${theme}${tall ? " dash-card--tall" : ""}`}>
    <button type="button" className="dash-card__arrow" onClick={onClick} aria-label={`Open ${title}`}>
      <FaArrowCircleRight />
    </button>

    <div className="dash-card__icon">
      <img src={icon} alt="" />
    </div>

    <div className="dash-card__body">
      <p className="dash-card__title">{title}</p>
      <h3 className="dash-card__value">{value}</h3>
    </div>

    <div className="dash-card__bar">
      <span />
    </div>
  </div>
);

// info = "Showing 1 to 10 of 50 entries" (optional), compact = small panel pager
const DashPagination = ({ page, totalPages, onPage, info, compact = false }) => (
  <div className={`dash-pagination${compact ? " dash-pagination--end" : ""}`}>
    {info && <div className="dash-pagination-info">{info}</div>}

    <div className="dash-pagination-controls">
      <button
        type="button"
        className="dash-nav-btn"
        onClick={() => onPage(Math.max(page - 1, 1))}
        disabled={page === 1}
      >
        ‹ Previous
      </button>

      <div className="dash-page-numbers">
        {getPageNumbers(page, totalPages).map((n, i) =>
          n === "..." ? (
            <span key={`dots-${i}`}>...</span>
          ) : (
            <button
              type="button"
              key={n}
              className={page === n ? "is-active" : ""}
              onClick={() => onPage(n)}
            >
              {n}
            </button>
          ),
        )}
      </div>

      <button
        type="button"
        className="dash-nav-btn"
        onClick={() => onPage(Math.min(page + 1, totalPages))}
        disabled={page >= totalPages}
      >
        Next ›
      </button>
    </div>
  </div>
);

const PhotoInfoRow = ({ icon, label, value }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "7px", fontSize: "11px" }}>
    <span
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: PHOTO_THEME.iconBg,
        color: PHOTO_THEME.icon,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        flexShrink: 0,
      }}
    >
      {icon}
    </span>
    <span>
      <b>{label}:</b> {value}
    </span>
  </div>
);

/* =====================================================================
   MAIN COMPONENT
   ===================================================================== */
const Dashboard = () => {
  const content = useContext(AdminContext);
  const {
    GetProjectDashboardData,
    GetTaxAmounts,
    GetVendorBills,
    GetDateWiseData,
    GetProjectInfo,
    GetBudgetHeadInfo,
  } = content;

  /* ---------------- filters / selections ---------------- */
  const [scheme, setScheme] = useState("");
  const [headId, setheadId] = useState("");
  const [projectId, setProjectId] = useState("");

  const [loading, setloading] = useState(true);
  const [getData, SetData] = useState({});
  const [dateData, setDateData] = useState([]);
  const [vendorbills, setVendorBills] = useState([]);
  const [deductionData, setDeductionData] = useState([]);

  const [projectdata, setProjectData] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [schemeProjectIds, setSchemeProjectIds] = useState([]);
  const [headFetchedData, setHeadFetchedData] = useState([]);

  /* ---------------- drill-down tables ---------------- */
  const [showTable, setShowTable] = useState("");
  const [projectTableData, setProjectTableData] = useState([]);
  const [progressTableData, setProgressTableData] = useState([]);
  const [estimateTableData, setEstimateTableData] = useState([]);
  const [limitAllocationTableData, setLimitAllocationTableData] = useState([]);
  const [workOrderTableData, setWorkOrderTableData] = useState([]);
  const [demandTableData, setDemandTableData] = useState([]);
  const [deductionTableData, setDeductionTableData] = useState([]);
  const [headDetailsTableData, setHeadDetailsTableData] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [deductionDetails, setDeductionDetails] = useState([]);

  /* ---------------- photo viewer ---------------- */
  const [showSpecific, setShowSpecific] = useState(0);
  const [FetchedImages, setFetchedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedUploadId, setSelectedUploadID] = useState();
  const [currentSlide, setCurrentSlide] = useState(0);

  /* ---------------- search boxes ---------------- */
  const [projectSearchTerm, setProjectSearchTerm] = useState("");
  const [progressSearchTerm, setProgressSearchTerm] = useState("");
  const [workOrderSearchTerm, setWorkOrderSearchTerm] = useState("");
  const [limitSearchTerm, setLimitSearchTerm] = useState("");
  const [demandSearchTerm, setDemandSearchTerm] = useState("");
  const [deductionSearchTerm, setDeductionSearchTerm] = useState("");
  const [estimateSearchTerm, setEstimateSearchTerm] = useState("");
  const [deductionDetailsSearchTerm, setDeductionDetailsSearchTerm] = useState("");
  const [headSearchTerm, setHeadSearchTerm] = useState("");

  /* ---------------- page numbers (auto reset to 1) ---------------- */
  const [projectPage, setProjectPage] = usePage([projectTableData, projectSearchTerm]);
  const [progressPage, setProgressPage] = usePage([progressTableData, progressSearchTerm]);
  const [estimatePage, setEstimatePage] = usePage([estimateTableData, estimateSearchTerm]);
  const [limitPage, setLimitPage] = usePage([limitAllocationTableData, limitSearchTerm]);
  const [workOrderPage, setWorkOrderPage] = usePage([workOrderTableData, workOrderSearchTerm]);
  const [demandPage, setDemandPage] = usePage([demandTableData, demandSearchTerm]);
  const [deductionPage, setDeductionPage] = usePage([deductionTableData, deductionSearchTerm]);
  const [headDetailsPage, setHeadDetailsPage] = usePage([headDetailsTableData, headId, headSearchTerm]);
  const [vendorPage, setVendorPage] = usePage([vendorbills]);
  const [headPanelPage, setHeadPanelPage] = usePage([headFetchedData]);

  /* ---------------- donut / pie chart state ---------------- */
  const [donutState, setDonutState] = useState({
    series: [0, 0, 0, 0],
    options: DONUT_BASE_OPTIONS,
  });
  const [pieState, setPieState] = useState({ series: [], options: DEDUCTION_PIE_BASE });

  /* =====================================================================
     DATA LOADING
     ===================================================================== */
  const GetAllProjectTotal = async () => {
    try {
      const data = await GetProjectInfo(" ", "getProjectsByHead");
      const projects = Array.isArray(data) ? data : [];
      const uniqueProjects = Array.from(
        new Map(projects.map((project) => [project.ProjectId, project])).values(),
      );
      setProjectData(uniqueProjects);
      setFilteredProjects(uniqueProjects);
    } catch (err) {
      console.error("Error fetching projects:", err);
      setProjectData([]);
      setFilteredProjects([]);
    }
  };

  const GetHeadBuget = async () => {
    try {
      const res = await GetBudgetHeadInfo("null", "all");
      setHeadFetchedData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error("GetHeadBuget error:", err);
    }
  };

  const loadHeadTable = async () => {
    try {
      const data = await GetProjectDashboardData(projectId || "", "head");
      setHeadDetailsTableData(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setHeadDetailsTableData([]);
    }
  };

  const getVendorbill = async () => {
    const data1 = await GetVendorBills();
    const bills = (data1 || []).filter((item) => item.BillNumber == projectId);
    setVendorBills(bills);
  };

  const getDateWiseData = async () => {
    if (!projectId) return;
    setloading(true);
    const data = await GetDateWiseData(projectId, "Projectfetching");
    if (data) {
      setDateData(data);
      setloading(false);
    }
  };

  const getDeductionData = async () => {
    try {
      setloading(true);
      const data = await GetDateWiseData(projectId, "deductionFetching");
      setDeductionData(data);
    } catch (err) {
      console.log(err);
    } finally {
      setloading(false);
    }
  };

  // first load
  useEffect(() => {
    GetAllProjectTotal();
    GetHeadBuget();
    loadHeadTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // top-card numbers (per scheme)
  useEffect(() => {
    const fetchSchemeData = async () => {
      try {
        setloading(true);
        const data = await GetTaxAmounts(scheme);
        SetData(data || {});
      } catch (error) {
        console.error("GetTaxAmounts error:", error);
        SetData({});
      } finally {
        setloading(false);
      }
    };
    fetchSchemeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheme]);

  // drill-down tables
  useEffect(() => {
    let cancelled = false;

    const fetchTableData = async () => {
      try {
        const currentProjectId = projectId || "";
        const currentScheme = scheme || "";
        const ids = Array.isArray(schemeProjectIds) ? schemeProjectIds : [];
        const load = (type) =>
          GetProjectDashboardData(currentProjectId, type, "", currentScheme, ids);

        const project = await load("project");
        const progress = await load("progress");
        const estimate = await load("estimateTable");
        const limitAllocation = await load("limitAllocation");
        const workOrders = await load("workOrders");
        const demands = await load("demandGenerations");
        const deductions = await load("deductionAmount");

        if (cancelled) return;

        setProjectTableData(sortLatestFirst(project));
        setProgressTableData(sortLatestFirst(progress));
        setEstimateTableData(sortLatestFirst(estimate));
        setLimitAllocationTableData(sortLatestFirst(limitAllocation));
        setWorkOrderTableData(sortLatestFirst(workOrders));
        setDemandTableData(sortLatestFirst(demands));
        setDeductionTableData(sortLatestFirst(deductions));
      } catch (error) {
        if (!cancelled) console.error("Table fetch error:", error);
      }
    };

    fetchTableData();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, scheme, schemeProjectIds]);

  // single project selected -> its numbers, vendor bills, deductions, heads
  useEffect(() => {
    if (projectId === "") {
      setDateData({});
      return;
    }
    getDateWiseData();
    getVendorbill();
    getDeductionData();
    loadHeadTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  /* =====================================================================
     CHART DATA
     ===================================================================== */
  const displayData = projectId ? dateData : getData;

  // donut (log scale so tiny values stay visible)
  useEffect(() => {
    const data = projectId ? dateData : getData;
    const raw = [
      Number(data?.Project_Cost || 0),
      Number(data?.Esitmate_Amount || 0),
      Number(data?.ReleaseAmountTillDate || 0),
      Number(data?.LiabalityAmount || 0),
    ];
    const transformed = raw.map((v) => (v > 0 ? Math.log10(v + 1) : 0));

    setDonutState((prev) => ({
      ...prev,
      series: transformed,
      options: { ...prev.options, rawValues: raw },
    }));
  }, [getData, dateData, projectId]);

  // deduction pie
  useEffect(() => {
    if (deductionData && deductionData.length > 0) {
      setPieState((prev) => ({
        ...prev,
        series: deductionData.map((item) => parseFloat(item.TotalAmount)),
        options: { ...prev.options, labels: deductionData.map((item) => item.TypeOfAmount) },
      }));
    }
  }, [deductionData]);

  // make apexcharts re-measure after data arrives
  useEffect(() => {
    const hasData =
      (deductionData && deductionData.length > 0) ||
      (getData && Object.keys(getData).length > 0) ||
      (dateData && Object.keys(dateData).length > 0);

    if (hasData) {
      const timer = setTimeout(() => window.dispatchEvent(new Event("resize")), 150);
      return () => clearTimeout(timer);
    }
  }, [getData, dateData, deductionData]);

  /* =====================================================================
     DERIVED VALUES
     ===================================================================== */
  const isBudget = scheme === "Budget";

  const schemeProjectCost = useMemo(() => {
    if (!scheme) return getData.Project_Cost || 0;
    return filteredProjects.reduce((sum, p) => sum + Number(p.ProjectCost || 0), 0);
  }, [scheme, filteredProjects, getData.Project_Cost]);

  const totalLimitAllocationAmount = useMemo(
    () =>
      limitAllocationTableData.reduce(
        (sum, item) => sum + Number(item.ReleaseAmountTillDate || item.ReleaseAmount || 0),
        0,
      ),
    [limitAllocationTableData],
  );

  // heads that are really used by at least one project
  const usedHeadIds = useMemo(
    () =>
      new Set(
        (projectdata || [])
          .map((p) => p.HeadID)
          .filter((id) => id !== undefined && id !== null && id !== "")
          .map((id) => String(id)),
      ),
    [projectdata],
  );

  const usedHeads = useMemo(() => {
    const filtered = (headFetchedData || []).filter((h) => usedHeadIds.has(String(h.HeadID)));
    return Array.from(new Map(filtered.map((h) => [h.HeadID, h])).values());
  }, [headFetchedData, usedHeadIds]);

  const headOptions = useMemo(
    () => usedHeads.map((h) => ({ value: String(h.HeadID), label: h.HeadName || h.BudgetHead || "-" })),
    [usedHeads],
  );

  const selectedHeadOption = useMemo(
    () => headOptions.find((o) => o.value === String(headId)) || null,
    [headOptions, headId],
  );

  const projectOptions = useMemo(
    () => (filteredProjects || []).map((p) => ({ value: String(p.ProjectId), label: p.ProjectName })),
    [filteredProjects],
  );

  const selectedProjectOption = projectOptions.find((o) => o.value === String(projectId)) || null;

  const headDetailsTableSource = headId
    ? headDetailsTableData.filter((item) => String(item.HeadID) === String(headId))
    : headDetailsTableData;

  const headsAssignsCount = headDetailsTableSource.length;

  // Head Details panel on the dashboard (grouped by head name)
  const headTableData = Object.entries(
    headFetchedData.reduce((acc, val) => {
      const headName = val.HeadName || "-";
      acc[headName] = (acc[headName] || 0) + (parseFloat(val.HeadSanctionAmount) || 0);
      return acc;
    }, {}),
  );
  const headPanelPg = paginate(headTableData, headPanelPage, HEADS_PER_PAGE);

  // Vendor Bills panel
  const vendorPg = paginate(vendorbills, vendorPage, BILLS_PER_PAGE);

  /* ---------------- filtered + paginated drill-down lists ---------------- */
  const getDeductionTotal = (item) => Number(item.TotalDeductionAmount ?? item.DeductionAmount ?? 0);

  const projectList = (projectTableData || []).filter((i) =>
    matches(i, projectSearchTerm, ["FinancialYear", "Scheme", "ProjectName", "Agency_Name", "PIU", "ProjectCost", "GRNumber"]),
  );
  const progressList = (progressTableData || []).filter((i) =>
    matches(i, progressSearchTerm, ["ProjectID", "ProjectName", "PhysicalProgress", "Description", "WorkOrderNo"]),
  );
  const estimateList = (estimateTableData || []).filter((i) =>
    matches(i, estimateSearchTerm, ["ProjectID", "ProjectName", "Year", "BudgetHead", "ObjectCode", "EsitmateAmount"]),
  );
  const limitList = (limitAllocationTableData || []).filter((i) =>
    matches(i, limitSearchTerm, ["ProjectName", "FinancialYear", "AgencyName", "Agency_Name", "LimitAmount", "ReleaseAmount", "ReleaseAmountTillDate"]),
  );
  const workOrderList = (workOrderTableData || []).filter((i) =>
    matches(i, workOrderSearchTerm, ["FinancialYear", "ProjectName", "ProjectCost", "CreatedByAgency", "WorkName", "WorkOrderNo"]),
  );
  const demandList = (demandTableData || []).filter((i) =>
    matches(i, demandSearchTerm, ["DemandGenerationID", "RABillNumber", "ContractorName", "WorkName", "BillAmount", "DeductionAmount", "NetPayableAmount"]),
  );
  const deductionList = (deductionTableData || [])
    .filter((i) => getDeductionTotal(i) > 0)
    .filter((i) =>
      matches(i, deductionSearchTerm, ["WorkOrderUID", "WorkOrderNo", "ProjectName", "WorkName", "Name", "ContractorName", "AgencyName"]),
    );
  const headDetailsList = headDetailsTableSource.filter((i) =>
    matches(i, headSearchTerm, ["FinancialYear", "HeadID", "HeadName", "ProjectName"]),
  );
  const deductionDetailsList = (deductionDetails || []).filter((item) => {
    const s = deductionDetailsSearchTerm.trim().toLowerCase();
    if (!s) return true;
    return (
      String(item.DeductionName || "").toLowerCase().includes(s) ||
      String(item.DeductionAmount || "").toLowerCase().includes(s) ||
      fmt(item.DeductionAmount).toLowerCase().includes(s)
    );
  });

  /* =====================================================================
     HANDLERS
     ===================================================================== */
  const handleSchemeChange = (selectedScheme) => {
    setScheme(selectedScheme);
    setProjectId("");
    setheadId("");

    setDateData({});
    setVendorBills([]);
    setDeductionData([]);

    setProjectTableData([]);
    setEstimateTableData([]);
    setLimitAllocationTableData([]);
    setWorkOrderTableData([]);
    setDemandTableData([]);
    setDeductionTableData([]);

    if (!selectedScheme) {
      setFilteredProjects(projectdata);
      setSchemeProjectIds([]);
      return;
    }

    const schemeProjects = projectdata.filter(
      (p) => String(p.Scheme).trim() === String(selectedScheme).trim(),
    );
    const uniqueProjects = Array.from(
      new Map(schemeProjects.map((p) => [p.ProjectId, p])).values(),
    );
    setFilteredProjects(uniqueProjects);
    setSchemeProjectIds(uniqueProjects.map((p) => p.ProjectId).filter(Boolean));
  };

  const handleHeadChange = (selectedHeadId) => {
    const id = String(selectedHeadId || "");
    setheadId(id);
    setProjectId("");

    if (!id) {
      setFilteredProjects(projectdata);
      return;
    }
    const projectsForHead = projectdata.filter((p) => String(p.HeadID) === id);
    const uniqueProjects = Array.from(
      new Map(projectsForHead.map((p) => [p.ProjectId, p])).values(),
    );
    setFilteredProjects(uniqueProjects);
  };

  const handleProjectChange = (selectedProjectId) => {
    setProjectId(selectedProjectId || "");
  };

  const getDeductionDetails = async (workOrderUID) => {
    setSelectedWorkOrder(workOrderUID);
    setDeductionDetailsSearchTerm("");
    const response = await GetProjectDashboardData(projectId, "deductionDetails", workOrderUID);
    setDeductionDetails(Array.isArray(response) ? response : []);
    setShowTable("deductionDetails");
  };

  const fetchSpecficUploadPhoto = async (uploadID) => {
    try {
      const res = await GetBudgetHeadInfo(uploadID, "GetSpecificUploadImagesfromProgressTable");
      const allImages = Array.isArray(res) ? res : Array.isArray(res?.Data) ? res.Data : [];
      const filteredImages = allImages.filter(
        (image) => String(image.UploadID).trim() === String(uploadID).trim(),
      );
      setFetchedImages(filteredImages);
      setSelectedUploadID(uploadID);
      setCurrentSlide(0);
      setShowSpecific(1);
    } catch (err) {
      console.error("Image API error:", err);
    }
  };

  const clearAllSearchTerms = () => {
    setProjectSearchTerm("");
    setProgressSearchTerm("");
    setWorkOrderSearchTerm("");
    setLimitSearchTerm("");
    setDemandSearchTerm("");
    setDeductionSearchTerm("");
    setEstimateSearchTerm("");
    setDeductionDetailsSearchTerm("");
    setHeadSearchTerm("");
  };

  // deduction details -> back to Deduction list; any other table -> dashboard
  const handleBack = () => {
    clearAllSearchTerms();
    if (showTable === "deductionDetails") {
      setShowTable("deduction");
      setSelectedWorkOrder(null);
      setDeductionDetails([]);
      return;
    }
    setShowTable("");
  };

  /* =====================================================================
     DRILL-DOWN TABLE DEFINITIONS
     (one place describes columns for every table)
     ===================================================================== */
  const projectPg = paginate(projectList, projectPage, PER_PAGE);
  const progressPg = paginate(progressList, progressPage, PER_PAGE);
  const estimatePg = paginate(estimateList, estimatePage, PER_PAGE);
  const limitPg = paginate(limitList, limitPage, PER_PAGE);
  const workOrderPg = paginate(workOrderList, workOrderPage, PER_PAGE);
  const demandPg = paginate(demandList, demandPage, PER_PAGE);
  const deductionPg = paginate(deductionList, deductionPage, PER_PAGE);
  const headDetailsPg = paginate(headDetailsList, headDetailsPage, PER_PAGE);

  const tableViews = {
    project: {
      list: projectList, pg: projectPg, page: projectPage, setPage: setProjectPage,
      empty: "No Project Found",
      cols: [
        { head: "Financial Year", cell: (r) => r.FinancialYear || "-" },
        { head: "Scheme", cell: (r) => r.Scheme || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Implementing Agency", link: true, cell: (r) => r.Agency_Name || r.PIU || "-" },
        { head: "Project Cost", amount: true, cell: (r) => rupee(r.ProjectCost) },
        { head: "GR Number", cell: (r) => r.GRNumber || "-" },
        { head: "GR Date", cell: (r) => fmtDate(r.GRDate) },
        { head: "Creation Date", cell: (r) => fmtDate(r.Date) },
      ],
    },
    head: {
      list: headDetailsList, pg: headDetailsPg, page: headDetailsPage, setPage: setHeadDetailsPage,
      empty: "No head projects Found",
      cols: [
        { head: "Head ID", link: true, cell: (r) => r.HeadID || "-" },
        { head: "Financial Year", cell: (r) => r.FinancialYear || "-" },
        { head: "Head Name", cell: (r) => r.HeadName || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
      ],
    },
    progress: {
      list: progressList, pg: progressPg, page: progressPage, setPage: setProgressPage,
      empty: "No Progress Found",
      cols: [
        { head: "Project ID", link: true, cell: (r) => r.ProjectID || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        {
          head: "Physical Progress",
          cell: (r) => (
            <button type="button" className="dash-view-btn" onClick={() => fetchSpecficUploadPhoto(r.UploadID)}>
              View Photos
            </button>
          ),
        },
        { head: "Remark", cell: (r) => r.Description || "-" },
        { head: "Date", cell: (r) => fmtDate(r.Date) },
      ],
    },
    estimate: {
      list: estimateList, pg: estimatePg, page: estimatePage, setPage: setEstimatePage,
      empty: "No Estimate Found",
      cols: [
        { head: "Project ID", link: true, cell: (r) => r.ProjectID },
        { head: "Project Name", cell: (r) => r.ProjectName },
        { head: "Financial Year", cell: (r) => r.Year },
        { head: "Budget Head", cell: (r) => r.BudgetHead },
        { head: "Object Code", cell: (r) => r.ObjectCode },
        { head: "Estimate Amount", amount: true, cell: (r) => rupee(r.EsitmateAmount) },
        { head: "Creation Date", cell: (r) => fmtDate(r.Date) },
      ],
    },
    limitAllocation: {
      list: limitList, pg: limitPg, page: limitPage, setPage: setLimitPage,
      empty: "No Limit Allocation Found",
      cols: [
        { head: "Limit ID", link: true, cell: (r) => r.ReleaseID },
        { head: "Financial Year", cell: (r) => r.FinancialYear },
        { head: "Project Name", cell: (r) => r.ProjectName },
        { head: "Limit Amount", amount: true, cell: (r) => rupee(r.ReleaseAmountTillDate) },
        { head: "Limit Date", cell: (r) => fmtDate(r.ReleaseDate) },
      ],
    },
    workOrder: {
      list: workOrderList, pg: workOrderPg, page: workOrderPage, setPage: setWorkOrderPage,
      empty: "No Work Order Found",
      cols: [
        { head: "Financial Year", cell: (r) => r.FinancialYear },
        { head: "Work Order Number", link: true, cell: (r) => r.WorkOrderNo },
        { head: "Project Name", cell: (r) => r.ProjectName },
        { head: "Project Cost", amount: true, cell: (r) => fmt(r.ProjectCost) },
        { head: "Agency Name", cell: (r) => r.CreatedByAgency },
        { head: "Work Name", cell: (r) => r.WorkName },
        { head: "Date", cell: (r) => fmtDate(r.WorkOrderDate) },
      ],
    },
    demand: {
      list: demandList, pg: demandPg, page: demandPage, setPage: setDemandPage,
      empty: "No Demand Found",
      cols: [
        { head: "Bill UID", link: true, cell: (r) => r.DemandGenerationID },
        { head: "RA Bill Number", cell: (r) => r.RABillNumber },
        { head: "Contractor Name", cell: (r) => r.ContractorName },
        { head: "Work Name", cell: (r) => r.WorkName },
        { head: "Bill Amount", amount: true, cell: (r) => rupee(r.BillAmount) },
        { head: "Deduction Amount", amount: true, cell: (r) => rupee(r.DeductionAmount) },
        { head: "Payable Amount", amount: true, cell: (r) => rupee(r.NetPayableAmount) },
      ],
    },
    deduction: {
      list: deductionList, pg: deductionPg, page: deductionPage, setPage: setDeductionPage,
      empty: "No Deduction Found",
      cols: [
        {
          head: "Work Order Number",
          cell: (r) => (
            <span className="dash-link" onClick={() => getDeductionDetails(r.WorkOrderUID)}>
              {r.WorkOrderUID}
            </span>
          ),
        },
        { head: "Project Name", cell: (r) => r.ProjectName },
        { head: "Work Name", cell: (r) => r.WorkName },
      ],
    },
  };

  // search box wiring: [value, setter, placeholder]
  const searchConfig = {
    project: [projectSearchTerm, setProjectSearchTerm, "Search Project..."],
    head: [headSearchTerm, setHeadSearchTerm, "Search Head..."],
    estimate: [estimateSearchTerm, setEstimateSearchTerm, "Search Estimate..."],
    progress: [progressSearchTerm, setProgressSearchTerm, "Search Progress Report..."],
    workOrder: [workOrderSearchTerm, setWorkOrderSearchTerm, "Search Work Order..."],
    limitAllocation: [limitSearchTerm, setLimitSearchTerm, "Search Limit Allocation..."],
    demand: [demandSearchTerm, setDemandSearchTerm, "Search Demand..."],
    deduction: [deductionSearchTerm, setDeductionSearchTerm, "Search Deduction..."],
    deductionDetails: [deductionDetailsSearchTerm, setDeductionDetailsSearchTerm, "Search Deduction Details..."],
  };
  const [searchValue, setSearchValue, searchPlaceholder] =
    searchConfig[showTable] || ["", () => {}, "Search..."];

  /* =====================================================================
     RENDER: PHOTO VIEWER
     ===================================================================== */
  const renderPhotoViewer = () => {
    const cards = [];

    (FetchedImages || []).forEach((val, index) => {
      const images = val.Upload ? val.Upload.split(",").map((img) => img.trim()) : [];

      const locations = (() => {
        try {
          if (!val.Location) return [];
          if (
            typeof val.Location === "string" &&
            val.Location.includes(",") &&
            !val.Location.startsWith("[")
          ) {
            const [lat, lng] = val.Location.split(",");
            const dt = val.Date ? new Date(val.Date) : null;
            return [
              {
                latitude: lat?.trim(),
                longitude: lng?.trim(),
                date: dt ? dt.toLocaleDateString("en-GB") : "-",
                time: dt ? dt.toLocaleTimeString("en-GB", { hour12: false }) : "-",
                elevation: "",
                accuracy: "",
              },
            ];
          }
          return parseLocations(val.Location);
        } catch {
          return [];
        }
      })();

      images.forEach((img, imgIndex) => {
        cards.push({
          key: `${index}-${imgIndex}`,
          img,
          location: locations[imgIndex] || locations[0] || {},
          progress: val.PhysicalProgress,
        });
      });
    });

    const total = cards.length;
    const current = cards[currentSlide] || cards[0];
    const loc = current?.location || {};
    const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
    const goNext = () => setCurrentSlide((p) => (p + 1) % total);

    const arrowStyle = (side) => ({
      position: "absolute",
      top: "50%",
      [side]: "10px",
      transform: "translateY(-50%)",
      width: "34px",
      height: "34px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "rgba(255,255,255,0.92)",
      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      color: "#333",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 2,
    });

    return (
      <div className="dash-photo-page">
        <h6 className="dash-photo-title">Uploaded Id: {selectedUploadId}</h6>

        {total > 0 ? (
          <div
            style={{
              maxWidth: "380px",
              margin: "0 auto",
              border: `1.5px solid ${PHOTO_THEME.border}`,
              borderRadius: "10px",
              backgroundColor: PHOTO_THEME.bg,
              padding: "10px",
            }}
          >
            {/* slider */}
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "240px",
                borderRadius: "14px",
                overflow: "hidden",
                backgroundColor: "#eee",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "100%",
                  transform: `translateX(-${currentSlide * 100}%)`,
                  transition: "transform 0.4s ease",
                }}
              >
                {cards.map((c) => (
                  <div
                    key={c.key}
                    style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
                    onClick={() => setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)}
                  >
                    <img
                      src={`${apiurl}/ProgressReport/${c.img}`}
                      alt="Uploaded"
                      loading="lazy"
                      decoding="async"
                      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  </div>
                ))}
              </div>

              {total > 1 && (
                <>
                  <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
                    <FaChevronLeft size={14} />
                  </button>
                  <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
                    <FaChevronRight size={14} />
                  </button>
                  <span
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "rgba(0,0,0,0.55)",
                      color: "#fff",
                      fontSize: "11px",
                      padding: "2px 8px",
                      borderRadius: "10px",
                    }}
                  >
                    {currentSlide + 1} / {total}
                  </span>
                </>
              )}
            </div>

            {/* dots */}
            {total > 1 && (
              <div style={{ display: "flex", justifyContent: "center", gap: "6px", margin: "10px 0 4px" }}>
                {cards.map((c, i) => (
                  <span
                    key={c.key}
                    onClick={() => setCurrentSlide(i)}
                    style={{
                      width: i === currentSlide ? "18px" : "8px",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor: i === currentSlide ? PHOTO_THEME.border : "#cfd4dc",
                      cursor: "pointer",
                      transition: "all 0.3s",
                    }}
                  />
                ))}
              </div>
            )}

            {/* info */}
            <div style={{ marginTop: "12px" }}>
              <PhotoInfoRow icon={<TbLocation />} label="Latitude" value={loc.latitude || "-"} />
              <PhotoInfoRow icon={<FaMapMarkerAlt />} label="Longitude" value={loc.longitude || "-"} />
              <PhotoInfoRow icon={<FaRegCalendarAlt />} label="Date" value={loc.date || "-"} />
              <PhotoInfoRow icon={<FaRegClock />} label="Time" value={loc.time || "-"} />
              <PhotoInfoRow
                icon={<FaMountain />}
                label="Elevation"
                value={`${loc.elevation && loc.elevation !== "-" ? loc.elevation : ""} m`}
              />
              <PhotoInfoRow
                icon={<FaBullseye />}
                label="Accuracy"
                value={`${loc.accuracy && loc.accuracy !== "-" ? loc.accuracy : ""} m`}
              />
              <PhotoInfoRow icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>No images found</div>
        )}

        <div className="text-center">
          <button style={{background:"white",border:"1px solid blue", color:"black"}}
            type="button"
            className="btn btn-primary fw-bold px-4 my-3"
            onClick={() => setShowSpecific(0)}
          >
             <img src={"/Back-Arrow-32.jpg"}  alt="Back Icon" className="Back-icon" style={{width:"25px", width:"25px",marginRight:"7px"}} />
            Back
          </button>
        </div>
      </div>
    );
  };

  /* =====================================================================
     RENDER: DASHBOARD HOME
     ===================================================================== */
  const renderHome = () => (
    <div className="dash-page">
      <h5 className="dash-page-title">
        <img src="/Dashboard-Blue-32.png" alt="" />
        Project Dashboard
      </h5>

      {/* ============ FILTER BAR ============ */}
<div className={`dash-filter-bar${!isBudget ? " dash-filter-bar--center" : ""}`}>
          <div className="dash-filter-group">
          <label className="dash-filter-label">Select Scheme :</label>
          <Select
            {...DASH_SELECT_PROPS}
            options={[
              { value: "Budget", label: "Budget" },
              { value: "NonBudget", label: "Non Budget" },
            ]}
            value={
              scheme
                ? { value: scheme, label: scheme === "NonBudget" ? "Non Budget" : "Budget" }
                : null
            }
            onChange={(o) => handleSchemeChange(o ? o.value : "")}
            placeholder="Select Scheme"
            styles={dashSelectStyles(190)}
          />
        </div>

        {isBudget && (
          <div className="dash-filter-group">
            <label className="dash-filter-label">Select Head :</label>
            <Select
              {...DASH_SELECT_PROPS}
              options={headOptions}
              value={selectedHeadOption}
              onChange={(o) => handleHeadChange(o ? o.value : "")}
              placeholder="Search/Choose Head"
              noOptionsMessage={() => "No head found"}
              styles={dashSelectStyles(200)}
            />
          </div>
        )}

        <div className="dash-filter-group">
          <label className="dash-filter-label">Select Project :</label>
          <Select
            {...DASH_SELECT_PROPS}
            options={projectOptions}
            value={selectedProjectOption}
            onChange={(o) => handleProjectChange(o ? o.value : "")}
            placeholder="Search/Choose Project"
            noOptionsMessage={() => "No project found"}
            styles={dashSelectStyles(250)}
          />
        </div>
      </div>

      {loading ? (
        <div className="dash-loader" />
      ) : (
        <>
          {/* ============ ROW 1 ============ */}
          <div className="dash-card-grid">
            <DashStatCard
              theme="blue"
              icon="/Total-Project.png"
              title="Total Project Cost"
              value={rupee(projectId ? displayData.Project_Cost : schemeProjectCost)}
              onClick={() => setShowTable("project")}
            />
            <DashStatCard
              theme="purple"
              icon="/Total-Limit-Allocation.png"
              title="Total Limit Allocation"
              value={rupee(projectId ? totalLimitAllocationAmount : displayData.ReleaseAmountTillDate)}
              onClick={() => setShowTable("limitAllocation")}
            />
            <DashStatCard
              theme="orange"
              icon="/Total-Work-Orders-100.png"
              title="Total Work Orders"
              value={fmt(displayData.TotalWorkOrders)}
              onClick={() => setShowTable("workOrder")}
            />
            <DashStatCard
              theme="green"
              icon="/Total-Progress-Report-100.png"
              title="Total Progress Report"
              value={fmt(progressTableData.length)}
              onClick={() => setShowTable("progress")}
            />
          </div>

          {/* ============ ROW 2 (Budget only) ============ */}
          {isBudget && (
            <div className="dash-card-grid">
              <DashStatCard
                theme="pink"
                icon="/MIS-Total-Number-Of-Vendor.png"
                title="Total Head Assign"
                value={fmt(headsAssignsCount)}
                onClick={() => {
                  setShowTable("head");
                  loadHeadTable();
                }}
              />
              <DashStatCard
                theme="indigo"
                icon="/Total-Estimate-Amount.png"
                title="Total Estimate Amount"
                value={rupee(displayData.Esitmate_Amount ?? getData.Esitmate_Amount)}
                onClick={() => setShowTable("estimate")}
              />
              <DashStatCard
                theme="teal"
                icon="/Total%20bill%20amt%20100%20Size.png"
                title="Total Bill Generation Amount"
                value={fmt(displayData.LiabalityAmount)}
                onClick={() => setShowTable("demand")}
              />
              <DashStatCard
                theme="red"
                icon="/Total-Deduction-Amount.png"
                title="Total Deduction Amount"
                value={rupee(displayData.TotalDeductionAmount)}
                onClick={() => setShowTable("deduction")}
              />
            </div>
          )}

          {/* ============ CHARTS ============ */}
          <div className={`dash-chart-grid${isBudget ? " dash-chart-grid--budget" : ""}`}>
            {/* Total Spend */}
            <div className="dash-chart-card">
              <h5 className="dash-chart-title">Total Spend</h5>
              <div className="dash-spend">
                <div className="dash-spend__summary">
                  <h1 className="dash-spend__amount">₹37.5K</h1>
                  <div className="dash-spend__row">
                    <p className="dash-spend__label">
                      Total
                      <br />
                      Spend
                    </p>
                    <p className="dash-spend__delta">+2.45%</p>
                  </div>
                  <h4 className="dash-spend__status">On track</h4>
                </div>

                <div className="dash-spend__chart">
                  <ReactApexChart
                    type="area"
                    height={300}
                    width="100%"
                    series={SPEND_SERIES}
                    options={SPEND_OPTIONS}
                  />
                </div>
              </div>
            </div>

            {/* Taxes And Amounts */}
            <div className="dash-chart-card">
              <h5 className="dash-chart-title">Taxes And Amounts</h5>
              <div className="dash-taxes-chart">
                {(deductionData?.length > 0
                  ? pieState.series.some((v) => v > 0)
                  : donutState.series.some((v) => v > 0)) ? (
                  <ReactApexChart
                    type="donut"
                    width={280}
                    options={deductionData?.length > 0 ? pieState.options : donutState.options}
                    series={deductionData?.length > 0 ? pieState.series : donutState.series}
                  />
                ) : (
                  <div className="dash-empty-chart">No data to display</div>
                )}
              </div>
            </div>

            {/* Non-Budget: tall cards on the right */}
            {!isBudget && (
              <div className="dash-side-cards">
                <DashStatCard
                  tall
                  theme="teal"
                  icon="/Total%20bill%20amt%20100%20Size.png"
                  title="Total Bill Generation Amount"
                  value={rupee(displayData.LiabalityAmount)}
                  onClick={() => setShowTable("demand")}
                />
                <DashStatCard
                  tall
                  theme="red"
                  icon="/Total-Deduction-Amount.png"
                  title="Total Deduction Amount"
                  value={rupee(displayData.TotalDeductionAmount)}
                  onClick={() => setShowTable("deduction")}
                />
              </div>
            )}
          </div>

          {/* ============ VENDOR BILLS + HEAD DETAILS ============ */}
          <div className="dash-bottom-grid">
            <div className="dash-panel">
              <h4 className="dash-panel-title">Vendor Bills</h4>

              <div className="dash-panel-scroll">
                <table className="dash-mini-table">
                  <thead>
                    <tr>
                      <th>Bill Number</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Progress</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendorPg.items.length < 1 ? (
                      <tr>
                        <td colSpan={5} className="dash-mini-empty">
                          No Bills Found
                        </td>
                      </tr>
                    ) : (
                      vendorPg.items.map((bill, i) => (
                        <tr key={i}>
                          <td>{bill.BillNumber}</td>
                          <td title={bill.Vendor_Company_Name || ""}>{bill.Vendor_Company_Name}</td>
                          <td>
                            <div className="dash-status">
                              <img
                                alt=""
                                src={
                                  bill.Status === "Sent to Bank" || bill.Status === "Successful/Paid"
                                    ? Approved32
                                    : Disable32
                                }
                              />
                              <span>{bill.Status === "false" ? "Approvals Pending" : bill.Status}</span>
                            </div>
                          </td>
                          <td>{bill.UploadedOn?.slice(0, 10)}</td>
                          <td>
                            <div className="dash-mini-bar">
                              <div className="dash-mini-bar__fill" />
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {vendorbills.length > 0 && (
                <DashPagination
                  compact
                  page={vendorPage}
                  totalPages={vendorPg.totalPages}
                  onPage={setVendorPage}
                />
              )}
            </div>

            <div className="dash-panel">
              <h4 className="dash-panel-title">Head Details</h4>

              <div className="dash-panel-scroll">
                <table className="dash-mini-table">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Sr. No</th>
                      <th style={{ width: "45%" }}>Budget Head</th>
                      <th style={{ width: "35%" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {headPanelPg.items.length > 0 ? (
                      headPanelPg.items.map(([budgetHead, totalAmount], i) => (
                        <tr key={budgetHead + i}>
                          <td>{headPanelPg.first + i + 1}</td>
                          <td title={budgetHead}>{budgetHead}</td>
                          <td>{rupee(totalAmount)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="dash-mini-empty">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {headTableData.length > 0 && (
                <DashPagination
                  compact
                  page={headPanelPage}
                  totalPages={headPanelPg.totalPages}
                  onPage={setHeadPanelPage}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );

  /* =====================================================================
     RENDER: DRILL-DOWN TABLE PAGE
     ===================================================================== */
  const renderDeductionDetails = () => (
    <div className="dash-table-card">
      <div className="dash-table-scroll">
        <h5 style={{ margin: "14px 16px" }}>Work Order: {selectedWorkOrder}</h5>
        <table className="dash-table">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Deduction Name</th>
              <th>Deduction Amount</th>
            </tr>
          </thead>
          <tbody>
            {deductionDetailsList.length > 0 && (
              <>
                {deductionDetailsList.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.DeductionName}</td>
                    <td>{rupee(item.DeductionAmount)}</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: "bold" }}>
                  <td colSpan={2}>TOTAL</td>
                  <td>
                    {rupee(
                      deductionDetailsList.reduce((sum, item) => sum + Number(item.DeductionAmount || 0), 0),
                    )}
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {deductionDetailsList.length === 0 && (
          <div className="dash-empty">No Deduction Details Found</div>
        )}
      </div>
    </div>
  );

  const renderTableBody = () => {
    if (showTable === "deductionDetails") return renderDeductionDetails();

    const v = tableViews[showTable];
    if (!v) return null;

    return (
      <div className="dash-table-card">
        <div className="dash-table-scroll">
          <table className="dash-table">
            <thead>
              <tr>
                <th>Sr.No</th>
                {v.cols.map((c) => (
                  <th key={c.head}>{c.head}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {v.pg.items.map((item, i) => (
                <tr key={item.ID ?? i}>
                  <td>{v.pg.first + i + 1}</td>
                  {v.cols.map((c) => (
                    <td key={c.head} className={c.link ? "dash-cell-link" : c.amount ? "dash-cell-amount" : undefined}>
                      {c.cell(item)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {v.pg.items.length === 0 && <div className="dash-empty">{v.empty}</div>}
        </div>

        {v.list.length > 0 && (
          <DashPagination
            page={v.page}
            totalPages={v.pg.totalPages}
            onPage={v.setPage}
            info={`Showing ${v.pg.first + 1} to ${Math.min(v.pg.last, v.list.length)} of ${v.list.length} entries`}
          />
        )}
      </div>
    );
  };

  const renderTablePage = () => (
    <div className="dash-table-page">
      <div className="dash-table-head">
        <div className="dash-table-head__left">
          <button type="button" className="dash-back-btn" onClick={handleBack} aria-label="Back">
            <span className="dash-back-btn__icon"><FaUndoAlt /></span>
          </button>
          <h4 className="dash-table-title">{TABLE_TITLES[showTable]}</h4>
        </div>

        <div className="dash-search">
          <img src="/Search-32.png" alt="" className="dash-search-icon" />
          <input
            type="text"
            className="dash-search-input"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>

      {renderTableBody()}
    </div>
  );

  /* =====================================================================
     RETURN
     ===================================================================== */
  return (
    <>
      {showSpecific === 1 ? renderPhotoViewer() : showTable === "" ? renderHome() : renderTablePage()}

      {selectedImage && (
        <div className="dash-photo-lightbox" onClick={() => setSelectedImage(null)}>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "25px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#000",
              fontSize: "25px",
              fontWeight: "bold",
              cursor: "pointer",
              zIndex: 100000,
            }}
          >
            ×
          </button>
          <img
            src={selectedImage}
            alt="Uploaded Progress Report"
            draggable={false}
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "block",
              width: "auto",
              height: "auto",
              maxWidth: "95vw",
              maxHeight: "95vh",
              objectFit: "contain",
              borderRadius: "6px",
              boxShadow: "0 0 20px rgba(255,255,255,0.25)",
            }}
          />
        </div>
      )}
    </>
  );
};

export default Dashboard;